export const zh = {
  createDefinitionModuleInstead: "改为创建定义式闪卡",
  createLanguageModuleInstead: "改为创建跨语言闪卡",
  flashcardLanguage: "闪卡语言",
  definitionFlashcards: "定义式闪卡",
  term: "术语",
  definition: "定义",
  definitions: "定义",
  // App Banner
  appTitle: "SafaCards",
  home: "首页",
  myModules: "我的模块",
  profile: "个人资料",
  logOut: "退出登录",

  // Profile Page
  myProfile: "我的个人资料",
  email: "邮箱",
  name: "姓名",
  baseAppLanguage: "应用基础语言",
  accountCreated: "账户已创建",
  appLanguage: "应用语言",
  profileEditingComingSoon: "（个人资料编辑功能即将推出）",
  deleteAccount: "删除账户",
  deletingAccount: "正在删除账户...",

  // Dashboard
  welcome: "欢迎回来！选择一个模块开始学习或创建一个新模块。",
  createNewModule: "创建新模块",
  editModules: "编辑模块",
  noModulesYet: "还没有模块。创建一个开始吧！",
  startLearning: "开始创建您的第一个模块吧！",
  wordGroup: {
    plural: (count) => count === 1 ? "单词组" : "单词组" // Chinese doesn't change for plural
  },
  flashcard: {
    plural: (count) => count === 1 ? "闪卡" : "闪卡" // Chinese doesn't change for plural
  },
  noWordGroupsYet: "还没有单词组",
  created: "已创建",
  total: "总计",
  resume: "继续",
  currentPlan: "当前计划",
  planFree: "免费",
  planPro: "高级版",
  expiresOn: "到期于",
  upgradeToPremium: "升级到高级版",
  wantToLearnMore: "想要学习更多？",
  dailyUsage: "每日使用量",
  wordsGenerated: "已生成单词",
  practiceSessions: "练习会话",
  of: "/",

  // Create Module
  createModule: "创建模块",
  createWords: "创建单词",
  moduleName: "模块名称",
  moduleNamePlaceholder: "例如，西班牙语基础，法语会话",
  moduleNameRequired: "模块名称是必需的",
  moduleNameMaxLength: "模块名称不能超过150个字符",
  moduleNameHelp: "模块是一组与某种语言相关的单词组和闪卡。给它取一个清晰的名字，方便以后查找。",
  targetLanguage: "目标语言",
  description: "描述",
  create: "创建",
  creating: "创建中...",
  iSpeak: "我讲...",
  iWantToLearn: "我想学习...",
  pleaseFillAllRequiredFields: "请填写所有必填字段。",
  pleaseSelectDifferentLanguages: "请选择两种不同的语言。",
  invalidLanguageSelection: "无效的语言选择。请选择支持的语言。",
  flashcardSetLimitReached: "集合中的闪卡太多，无法使用AI生成更多。",
  createANewModule: "创建新模块",

  // Learn Topic Page
  learnATopic: "学习主题：",
  howWouldYouLikeToAddWords: "您想如何添加单词？",
  enterTopicToLearn: "输入要学习的主题",
  regionDialectOptional: "地区/方言（可选）：",
  numberOfWords: "单词数量：",
  topic: "主题",
  topicPlaceholder: "例如：食物、旅行、商业",
  topicMaxLength: "主题不能超过100个字符",
  dialectMaxLength: "方言不能超过50个字符",
  dialectPlaceholder: "例如：墨西哥、哥伦比亚、卡斯蒂利亚",
  topicHelp: "主题告诉 AI 应该为你的第一个单词组生成哪一类词汇（例如：食物、旅行或商业）。",
  noWordsGenerated: "未生成单词。请尝试其他主题。",
  failedToGenerateWords: "生成单词失败。",

  // Add Flashcard Group
  createANewWordGroup: "创建新单词组",
  giveGroupNameAndAddWords: "为你的新组命名并在下面添加单词。",
  groupName: "组名",
  groupNamePlaceholder: "例如：常用问候语",
  groupNameMaxLength: "组名不能超过100个字符",
  toLangMaxLength: "翻译不能超过150个字符",
  pleaseProvideGroupNameAndWords: "请提供组名并填写所有单词对。",
  createWordGroup: "创建单词组",

  // Flashcard Mode Page
  chooseFlashcardMode: "选择闪卡模式",
  selectHowToPractice: "选择您想要练习闪卡的方式",
  learningMode: "学习模式",
  learningModeDescription: "无限复习与间隔重复。专注于学习，提供✓/✗反馈。",
  learningModeFeature1: "仅✓/✗按钮 - 无导航",
  learningModeFeature2: "基于SRS数据的智能单词选择",
  learningModeFeature3: "无限练习直到您准备停止",
  learningModeFeature4: "适合专注学习会话",
  startLearningMode: "开始学习模式",
  classicMode: "经典模式",
  classicModeDescription: "传统闪卡体验，具有完整的导航控制。",
  classicModeFeature1: "上一个/下一个导航按钮",
  classicModeFeature2: "卡片计数器（1/50、2/50等）",
  classicModeFeature3: "洗牌选项",
  classicModeFeature4: "键盘快捷键（箭头、空格）",
  startClassicMode: "开始经典模式",

  // Module Page
  reviewModes: "复习模式",
  reviewModesSubtitle: "下面的每种模式都专注于一种不同的复习方式：",
  reviewAllDueWordsLabel: "复习所有到期单词",
  reviewAllDueWordsDescription: "使用 SM2 复习已经到期需要复习的单词。",
  learnUnmasteredWordsDescription: "在学习模式下复习尚未掌握的单词。",
  reviewWeakWordsDescription: "重点复习你经常做错或拿不准的单词。",
  reviewForgottenWordsDescription: "复习很久没有见过的单词，根据它们的 SRS 历史来选择。",
  allWordsLearningMode: "全部单词学习模式",
  allWordsLearningModeDescription: "按学习进度加权，无限复习所有卡片。",
  randomWordReview: "随机单词复习",
  randomWordReviewDescription: "每次随机选择一张卡片进行无限学习模式复习。",
  module: "模块",
  moduleNotFound: "模块未找到",
  moduleNotFoundMessage: "您要查找的模块不存在或已被删除。",
  backToDashboard: "返回仪表板",
  backToModules: "返回模块",
  addWords: "添加单词",
  learnTopic: "学习主题",
  flashcards: "闪卡",
  conversation: "对话",
  practice: "练习",
  story: "故事",
  deleteModule: "删除模块",
  areYouSureDelete: "您确定要删除这个模块吗？",
  areYouSureDeleteWordGroup: "您确定要删除单词组",
  wordGroups: "单词组",
  view: "查看",

  // Word Group Page
  wordGroupNotFound: "单词组未找到",
  wordGroupNotFoundMessage: "您查找的单词组不存在或已被删除。",
  backToModule: "← 返回模块",
  startFlashcards: "开始闪卡",
  practiceSentences: "练习句子",
  readAStory: "阅读故事",
  editWords: "编辑单词",
  saveChanges: "保存更改",
  saving: "保存中...",
  errorUpdatingModuleNames: "更新模块名称时出错。请重试。",
  deleteWord: "删除单词",
  showKeyboard: "显示键盘",

  // Add Words
  addMoreWords: "添加更多单词",
  addWordsManually: "手动添加单词",
  generateWithAI: "使用AI生成",
  word: "单词",
  translation: "翻译",
  addWord: "添加单词",
  generateWords: "生成单词",
  generating: "生成中...",
  pleaseAddAtLeastOne: "请至少添加一个完整的单词对。",
  failedToFetchWords: "从AI获取单词失败。",
  generatingWords: "正在生成单词，请稍候...",
  creatingWordGroup: "正在创建单词组，请稍候...",
  addAnotherWord: "+ 添加另一个单词",
  letAIGenerateWords: "让AI为主题生成新单词：",
  numberOfWordsToGenerate: "要生成的单词数量：",
  generateAndAddWords: "生成并添加单词",

  // Flashcards
  flashcardMode: "闪卡模式",
  practiceMode: "练习模式",
  next: "下一个",
  previous: "上一个",
  flip: "翻转",
  markAsKnown: "标记为已知",
  markAsUnknown: "标记为未知",
  known: "已知",
  unknown: "未知",

  // Flashcard Status Labels
  newWord: "新单词",
  needsWork: "需要练习",
  gettingThere: "正在进步",
  nearlyMastered: "几乎掌握",
  mastered: "已掌握",

  // Flashcard Settings
  onFront: "在前面",
  randomSideOnFront: "随机一面朝前",
  resetProgress: "重置进度",
  markAsMastered: "标记为已掌握",
  cancel: "取消",
  flashcardSettings: "闪卡设置",
  removeWordPair: "删除单词对",

  // Flashcard Feedback
  iDidntKnowIt: "我不知道",
  iKnewIt: "我知道",

  // Flashcards Page
  exitFlashcards: "退出闪卡",
  loadingFlashcards: "加载闪卡中...",
  prev: "上一个",
  shuffleCards: "洗牌",
  flashcardHotkeys: "使用 ← 和 → 导航，空格键翻转卡片。",
  learningModeInfo: "学习模式：使用 ✓ 或 ✗ 前进，或使用 ←/→ 箭头键。无限复习。",

  // Sentence Practice Page
  generatingSentences: "正在生成句子，请稍候...",
  backToWordGroup: "返回单词组",
  checkAnswers: "检查答案",
  practiceAgainWithNewSentences: "用新句子再次练习",
  correct: "正确！",
  incorrect: "错误。答案是：",

  // Story Summary Page
  generatingStory: "正在生成故事，请稍候...",
  aiFeedback: "AI 反馈",
  done: "完成",
  writeSummary: "写一个故事摘要（用任何语言）：",
  evaluating: "评估中...",
  submitSummary: "提交摘要",
  failedToGenerateStory: "生成故事失败。",
  needAtLeastTenWords: "您需要在此组中至少10个单词才能生成故事。",
  failedToEvaluateSummary: "评估摘要失败。",
  generateAnotherStory: "生成另一个故事",

  // Conversation
  startConversation: "开始对话",
  send: "发送",
  typeMessage: "输入您的消息...",

  // Practice
  fillInTheBlank: "填空：",
  check: "检查",
  nextSentence: "下一句",

  // Common
  loading: "加载中...",
  save: "保存",
  edit: "编辑",
  delete: "删除",
  back: "返回",
  continue: "继续",
  submit: "提交",
  close: "关闭",

  // Accessibility
  skipToMainContent: "跳转到主要内容",
  flipCardToFront: "翻转卡片到正面",
  flipCardToBack: "翻转卡片到背面",
  openProfileMenu: "打开个人资料菜单",
  openMenu: "打开菜单",
  closeKeyboard: "关闭键盘",
  space: "空格",
  google: "Google",
  advertisement: "广告",
  errorDetailsDevelopment: "错误详情（开发）",

  // Errors
  error: "错误",
  somethingWentWrong: "出现错误",
  tryAgain: "重试",
  networkError: "网络错误",
  unexpectedError: "很抱歉，发生了意外情况。请尝试刷新页面。",
  errorOccurred: "发生错误。请稍后重试。",
  aiTyping: "AI正在输入...",
  aiCouldNotGenerateSentences: "AI无法为此单词组生成句子。请尝试另一个。",
  couldNotConnectToAI: "无法连接到AI服务。",
  failedToDeleteAccount: "删除账户失败：",
  areYouSureDeleteAccount: "您确定要删除您的账户吗？此操作无法撤销。",
  manageSubscription: "管理订阅",
  failedToManageSubscription: "管理订阅失败：",
  noSubscriptionsToManage: "您尚未购买任何内容，也没有可管理的订阅。",
  inappropriateContentDetected: "检测到不当内容。请使用适当的语言。",
  pleaseLogIn: "请登录以继续。",

  // Classrooms
  classrooms: "教室",
  createClassroom: "创建教室",
  joinClassroom: "加入教室",
  classroomName: "教室名称",
  enterClassroomName: "输入教室名称",
  pleaseEnterClassroomName: "请输入教室名称",
  classroomCode: "教室代码",
  enterClassroomCode: "输入教室代码",
  pleaseEnterClassroomCode: "请输入教室代码",
  getCodeFromTeacher: "从老师那里获取代码",
  classroomCreated: "教室已创建！",
  shareThisCode: "与学生分享此代码：",
  classroomCodeInstructions: "学生可以使用此代码加入您的教室。",
  createAnother: "创建另一个教室",
  failedToCreateClassroom: "创建教室失败",
  invalidClassroomCode: "无效的教室代码",
  alreadyMember: "您已经是此教室的成员",
  joinedClassroom: "成功加入教室！",
  failedToJoinClassroom: "加入教室失败",
  copiedToClipboard: "已复制到剪贴板！",
  failedToCopy: "复制失败",
  copy: "复制",
  joining: "加入中...",
  myClassrooms: "我的教室",
  manageClassrooms: "管理教室",
  noModulesInClassroom: "此教室中还没有模块",
  head: "负责人",
  errorFetchingClassrooms: "加载教室失败",
  createClassroomModule: "在教室中创建模块",
  classroomPassword: "教室密码",
  students: "学生",
  classUsername: "课堂用户名",
  saveClassSettings: "保存设置",
  reshuffleCode: "重新生成代码",
  errorUpdatingClassSettings: "更新教室设置失败",
  editClassSettings: "更新教室",
  reshuffling: "正在重新生成代码...",
  subscriptionStatus: "订阅状态",
  expired: "已过期",
  expiresSoon: "即将过期",
  active: "活跃",
  expires: "过期",
  renewSubscription: "续订订阅",
  activateSubscription: "激活订阅",
  activating: "激活中...",
  failedToActivateSubscription: "激活订阅失败",
  processing: "处理中...",
  proceedToPayment: "前往支付",
  paymentRequiredNotice: "创建教室需要支付。支付成功后，您的教室将被创建。",
  classroomPaymentSuccess: "支付成功！您的教室已创建。",
  paymentCanceled: "支付已取消。教室未创建。",
  classroomTier: "教室等级",
  tierFamily: "家庭版（最多5名成员，600词/月）",
  tierBasic: "基础版（最多35名学生，1200词/月）",
  tierStandard: "标准版（最多150名学生，5000词/月）",
  billingCycle: "计费周期",
  billingPlan: "计费计划",
  planMonthly: "月付",
  planSemester: "学期（4个月）",
  planYearly: "年付",
  monthly: "月付",
  semester: "学期（4个月）",
  yearly: "年付",
  recurringPaymentNotice: "除非取消，否则付款将自动续期。您可以随时在教室设置中取消。",
  upgradeToBasic: "升级至35名学生",
  upgradeToStandard: "升级至150名学生",
  upgradeToLarge: "升级至150名学生",
  failedToCreateCheckout: "创建支付会话失败",
  failedToRenewSubscription: "续订订阅失败",
  classroomSubscriptionExpired: "此教室订阅已过期，宽限期已结束。请联系您的老师续订订阅。",
  wordGenerationLimit: "单词生成限制",
  wordsThisMonth: "本月单词",
  remaining: "剩余",
  viewClass: "查看教室",
  classroomMembers: "教室成员",
  confirmRemoveStudent: "您确定要从教室中移除此学生吗？",
  removing: "移除中...",
  remove: "移除",
  joined: "加入",
  noMembersYet: "还没有成员加入此教室。",
  onlyClassroomHeadCanView: "只有教室负责人可以查看和管理教室。",
  errorFetchingClassroom: "获取教室数据时出错",
  errorRemovingStudent: "移除学生时出错",
  classroomNotFound: "未找到教室",
  classroomUsername: "教室用户名",
  enterClassroomUsername: "输入您的教室用户名",
  pleaseEnterClassroomUsername: "请输入教室用户名",
  classroomUsernameHelp: "这是您在此教室中向其他人显示的方式",
  classroomUsernameTooLong: "教室用户名不能超过100个字符",
  usernameAlreadyTaken: "此用户名在此教室中已被使用。请选择另一个。",
  teacher: "教师",
  student: "学生",
  coTeacher: "共同教师",
  promoteToCoTeacher: "提升为共同教师",
  promoteToTeacher: "提升为教师",
  demoteToStudent: "降为学生",
  promoteCoTeacherWarning: "警告：将此共同教师提升为教师会将您降为共同教师。您确定要继续吗？",
  errorChangingRole: "更改成员角色时出错",
  deleteClassroom: "删除教室",
  leaveClassroom: "离开教室",
  confirmDeleteClassroom: "您确定要删除此教室吗？这将永久删除教室、所有模块、词组、单词和所有学生进度。此操作无法撤销。",
  confirmLeaveClassroom: "您确定要离开此教室吗？这将删除您在此教室中的所有进度。",
  errorDeletingClassroom: "删除教室时出错",
  errorLeavingClassroom: "离开教室时出错",
  onlyTeachersCanDelete: "只有教师可以删除教室",
  teachersCannotLeave: "教师不能离开教室。请删除教室。",
  deleting: "删除中...",
  leaving: "离开中...",
  accessDenied: "访问被拒绝",

  errorFetchingModules: "加载模块失败。请重试。",
  errorFetchingModule: "获取模块失败。",
  errorCreatingModule: "创建模块失败。请重试。",
  errorCreatingWordGroup: "创建单词组失败。请重试。",
  dataNotLoaded: "数据未加载。请重试。",
  noWordsYet: "还没有单词",
  addYourFirstWords: "添加您的第一个单词开始学习！",
  errorDeletingSRS: "删除SRS记录失败。",
  errorDeletingModule: "删除模块失败。",
  logoutError: "登出失败",
  dailyPracticeLimitReached: "您已达到每日AI练习限制。",
  errorUpdatingProgress: "更新进度失败。请重试。",

  // Success
  success: "成功",
  saved: "保存成功",
  updated: "更新成功",
  deleted: "删除成功",

  // Language Names
  English: "英语",
  Spanish: "西班牙语",
  French: "法语",
  German: "德语",
  Italian: "意大利语",
  Portuguese: "葡萄牙语",
  Hebrew: "希伯来语",
  Yiddish: "意第绪语",
  Mandarin: "中文",
  Arabic: "阿拉伯语",
  Russian: "俄语",
  Korean: "韩语",
  Catalan: "加泰罗尼亚语",
  Vietnamese: "越南语",
  Cantonese: "粤语",
  about: "关于",
  privacyPolicy: "隐私政策",
  termsOfService: "服务条款",
  logIn: "登录",

  // Landing Page
  safaCards: "SafaCards",
  intelligentWayToMaster: "掌握新语言的智能方式。",
  learnLanguagesSmartWay: "智能学习语言",
  landingDescription: "我构建SafaCards是因为我厌倦了记忆那些永远不会使用的随机单词。现在您可以学习对您重要的词汇，用真实句子练习，并与真正了解您学习内容的AI导师聊天。",
  startLearningFree: "免费开始学习",
  blog: "博客",
  blogSubtitle: "SafaCards的最新文章、提示和更新",
  blogComingSoon: "博客文章即将推出！稍后再回来查看有关使用SafaCards学习语言的文章、提示和更新。",
  blogCardTitle: "专家语言学习见解",
  blogCardDescription: "发现基于科学的策略、实用技巧和经过验证的方法，以加速您的语言学习之旅。我们的博客提供关于间隔重复、记忆技巧、文化理解等的深入文章。",
  readOurBlog: "阅读我们的最新文章和提示",
  visitBlog: "访问博客",
  articleNotFound: "未找到文章",
  articleNotFoundMessage: "您要查找的文章不存在。",
  blogArticle1Title: "记忆科学：为什么我们会忘记70%的所学内容",
  blogArticle1Excerpt: "您是否曾经有过那样的'我真的在做这个'的夜晚—花一个小时在意大利语动词变位上，一堆日语汉字，也许是一本您发誓要保持整洁的新笔记本—结果第二天早上醒来，意识到您的大脑基本上耸了耸肩就继续了？",
  blogArticle1Author: "SafaCards团队",
  blogArticle1Content: `<p>您是否曾经有过那样的"我真的在做这个"的夜晚—花一个小时在意大利语动词变位上，一堆日语汉字，也许是一本您发誓要保持整洁的新笔记本—结果第二天早上醒来，意识到您的大脑基本上耸了耸肩就继续了？</p>
      
      <p>这令人沮丧。它也可能感觉个人化，就像您做错了什么。</p>
      
      <p>但大多数时候，您没有。您的大脑正在做它设计要做的事情：节省空间，节省能量，并坚持它认为您真正需要的东西。</p>
      
      <h2>遗忘曲线（又名死记硬背感觉像骗局的原因）</h2>
      <p>在19世纪末，一位名叫赫尔曼·艾宾浩斯的心理学家进行了一些关于记忆如何工作的第一批真正实验。他的结论很直接：人类忘记得很快—特别是当我们不重新审视所学内容时。</p>
      
      <p>人们经常从他工作和后续研究中引用的数字相当发人深省：没有复习，大量新信息在一天内就会消失，几周后您只剩下开始时的很小一部分。</p>
      
      <p>不是因为您懒惰。不是因为您"没有语言基因。"</p>
      <p>因为您的大脑在不断分类。它保留看起来有用的东西，让其余的消失。</p>
      
      <p>从您大脑的角度来看，外语中的一个全新单词基本上是…可能重要的杂物。它不会获得永久位置，直到您证明它很重要。</p>
      
      <h2>那么为什么它消失得这么快？</h2>
      <p>对于语言学习者来说，同样的罪魁祸首一次又一次地出现：</p>
      
      <p><strong>1) 您没有立即使用它。</strong></p>
      <p>如果您学了一个词然后再也没有看到它，您的大脑会把它归档为"不紧急。"</p>
      
      <p><strong>2) 您试图一次学太多。</strong></p>
      <p>死记硬背给您一个暂时的高潮（看我走！），但它对注意力和回忆很困难。您越超载，一切就越开始模糊在一起。</p>
      
      <p><strong>3) 您的复习太被动了。</strong></p>
      <p>一遍又一遍地读单词列表感觉像在学习，但您的大脑真的不需要工作。真正加强记忆的是主动回忆—试图从您的脑海中提取单词，即使一开始很混乱。</p>
      
      <h2>真正有效的修复：间隔重复</h2>
      <p>好消息是：遗忘不是敌人。它是系统。您可以与它合作。</p>
      
      <p>艾宾浩斯还注意到一些令人鼓舞的事情：如果您在即将忘记某件事的时候复习它，记忆会保持更长时间。这样做几次，"下降"就会急剧减慢。</p>
      
      <p>这种方法被称为间隔重复。</p>
      
      <p>它基本上是一个时间技巧：不是随机复习，而是有目的地复习—就在您的大脑开始放手的时候。每次您成功回忆起单词时，您的大脑收到消息："哦，我们要保留这个。"</p>
      
      <p>下次会变得更容易。然后再更容易。</p>
      
      <h2>SafaCards如何将这种科学转化为您真正会使用的东西</h2>
      <p>间隔重复在理论上很简单，但在现实生活中很烦人。最困难的部分不是记忆—而是记住要复习什么和什么时候。人们要么过度复习简单的东西，要么忘记重新审视困难的东西，直到它们消失。</p>
      
      <p>这正是我们构建SafaCards要解决的问题。</p>
      
      <p><strong>1) 每日复习，不需要规划您的整个生活</strong></p>
      <p>当您打开应用程序时，每日复习模式会给您一组简短、集中的"到期"单词—基于您之前的表现。不是一大堆。不是随机的。只是如果您忽略它们最可能滑落的东西。</p>
      
      <p>所以您把时间花在做重要的部分（回忆和练习）上，而不是用日历玩记忆管理器。</p>
      
      <h2>一个有助于的心态转变</h2>
      <p>很多人把遗忘当作他们不擅长语言的证明。但遗忘只是您的大脑在节约。它不断修剪和优先排序。</p>
      
      <p>真正的胜利是当您回到一个几乎忘记的单词并无论如何都把它拉出来时发生的事情。那个时刻—当它就在边缘时—是学习变得更强的地方。</p>
      
      <p>一致性是无聊的答案，但它也是正确的答案。大多数日子里几分钟的智能复习每次都会击败一次"学习马拉松"。如果您继续向您的大脑展示这些单词很重要，它就会停止扔掉它们。</p>
      
      <p>最终，那些感觉不可能的东西开始感觉…正常。就像它们属于那里一样。</p>`,
  blogArticle2Title: "如何建立一个10分钟的每日语言习惯（真正有效）",
  blogArticle2Excerpt: "我们都经历过：新年到了，你对自己承诺：'今年我终于要学西班牙语了。'到了1月15日，教科书已经积满灰尘。错误不在于你缺乏意志力；而在于你的策略。",
  blogArticle2Author: "SafaCards团队",
  blogArticle2Content: `<p>我们都经历过。新年到了，您就像"就是这样。今年我终于要学西班牙语了。"所以您买了教科书，下载了三个应用，连续学习两个小时。</p>
      
      <p>到了1月15日？那本教科书在您的书架上积满灰尘。</p>
      
      <p>问题是—这不是关于意志力。这是关于策略。当涉及到语言时，强度会杀死一致性。您不需要更多时间。您需要一个真正坚持的10分钟习惯。</p>
      
      <p>让我向您展示如何建立一些即使在您最疯狂的日子里也能坚持下去的东西。</p>
      
      <h2>"最小可行习惯"</h2>
      <p>建立习惯的诀窍？让它们变得如此之小，以至于跳过它们感觉荒谬。当您目标是一小时时，您的大脑开始找借口。"我太累了。" "我没有时间。" "也许明天。"</p>
      
      <p>但是10分钟？那不算什么。那是您煮咖啡所需的时间。那是一个广告时间。当门槛那么低时，您实际上会去做。在语言学习中，出现是90%的游戏。</p>
      
      <h3>1. 叠加您的习惯</h3>
      <p>建立新习惯最简单的方法？将其附加到您已经在做的事情上。詹姆斯·克利尔在他的《原子习惯》一书中称之为"习惯叠加"，它有效。</p>
      
      <p>不要说"我今天某个时候会学西班牙语。"那太模糊了。您的大脑会找到出路。</p>
      
      <p>相反，说"在我早上坐下来喝咖啡后，我会复习我的抽认卡。"现在您有了一个触发器。咖啡发生了，抽认卡发生了。简单。</p>
      
      <p>通过将您的语言练习与某些物理的东西联系起来—那杯咖啡—您消除了决策。没有心理能量浪费在"我应该什么时候做这个？"它只是发生了。</p>
      
      <h3>2. 杀死决策疲劳</h3>
      <p>大多数人放弃是因为他们花了一半的学习时间只是弄清楚要学什么。您应该读文章吗？看视频？练习语法？当您决定时，您的10分钟已经用完了。</p>
      
      <p>您需要一个为您做决定的系统。这就是好技术发挥作用的地方。您想要一些在您打开它的那一刻就告诉您确切该做什么的东西。不需要思考。</p>
      
      <h3>3. 使用为此构建的工具</h3>
      <p>听着，有一些应用程序专门设计来消除摩擦。好的那些？它们以习惯为先构建。它们消除了任何可能让您觉得"呃，这太麻烦了"的东西。</p>
      
      <h3>自动化每日复习</h3>
      <p>间隔重复系统是为10分钟学习者构建的。您不必想知道您在忘记什么。系统为您计算。每天早上，它向您显示哪些词到期了。您打开它，清除您的列表，完成。可能需要10分钟。非常适合早上的通勤或咖啡冲泡时。</p>
      
      <h3>无摩擦内容创建</h3>
      <p>最大的习惯杀手之一？遇到一个您不认识的词，必须停止一切来查找它，找翻译，写下来。这会完全打破您的流程。</p>
      
      <p>一些工具允许您将未知词立即转换为学习卡。看到一个您不认识的词？点击它，它就被保存了。不停顿。不整理。只是学习。您保持在那样的流程状态，时间消失了，您真的在进步。</p>
      
      <h3>快速复习模式</h3>
      <p>在那些甚至10分钟都感觉不可能的日子里？这就是您需要快速复习模式的时候。滑动浏览您的卡片组，标记您知道的内容，继续。它是低压力、快速的，并保持您的连续记录活跃。有时只出现两分钟就足以保持动力。</p>
      
      <h2>这是马拉松，不是短跑</h2>
      <p>一年后，您会希望今天就开始。每天只花10分钟使用一个真正有效的系统，到明年这个时候，您将投入超过60小时的真实学习。</p>
      
      <p>这就是希望您说一门语言和真正说它的区别。</p>`,
  blogArticle3Title: "主动回忆 vs. 被动复习：为什么您当前的学习方法在欺骗您",
  blogArticle3Excerpt: "我们都经历过：您在热门语言应用中保持了三个星期的'连续记录'，但当您真正尝试在现实世界中与某人交谈时，您的头脑一片空白。问题不在于您的记忆力—而是您一直被困在被动复习中。",
  blogArticle3Author: "SafaCards团队",
  blogArticle3Content: `<p>您知道那种感觉吗？您已经在某个语言应用中连续三周保持您的连续记录。匹配对子，将单词拖到框中，观看所有那些"快速学法语"的TikTok。您对自己感觉很好。</p>
      
      <p>然后您尝试真正与某人交谈。您的大脑只是...空了。甚至不记得如何问洗手间在哪里，更不用说进行真正的对话了。</p>
      
      <p>您的记忆力很好。问题？您一直被困在被动复习模式中。如果您想真正说话，您需要主动回忆。</p>
      
      <h2>"应用多巴胺"陷阱</h2>
      <p>大多数语言应用的设计目的是让您感觉良好，而不是让您快速学习。这就是我所说的"能力错觉"。</p>
      
      <p>被动复习是这样工作的：您看到一个多选题。正确答案就在那里。您的大脑识别它，给您一点多巴胺冲击。您想"是的，我知道这个！"</p>
      
      <p>但现实是：您不知道。您只是因为它就在您面前而认出了它。</p>
      
      <p>当您在墨西哥城参加晚宴时，没有单词库漂浮在周围。您必须从零开始从自己的大脑中提取那个词。这就是主动回忆。这就是真正建立流利的方法。</p>
      
      <h2>为什么心理努力很重要</h2>
      <p>认知科学中有一个概念叫做理想难度。基本上，您的大脑检索记忆越努力，该记忆就变得越强。</p>
      
      <p>点击按钮？容易。记忆保持薄弱。</p>
      
      <p>努力从空白抽认卡中回忆一个词？困难。但那个记忆变得持久得多。</p>
      
      <p>每次您在翻转卡片之前努力记住某些东西时，您实际上是在升级您的大脑硬件。您正在建立实时对话所需的神经通路。</p>
      
      <h2>真正有效的方法</h2>
      <p>所以问题是—如果您想真正说话，您需要迫使您的大脑做工作的工具。不是那些让您感觉良好、让您以为在学习而实际上只是在识别模式的东西。</p>
      
      <h3>1. 不再有多选题</h3>
      <p>跳过那些给您简单拐杖的应用程序。您想要让您自己产生答案的抽认卡。没有单词库。没有提示。只有您和您的记忆。一些工具允许您根据您实际想学习的内容创建自定义卡片—这就是内容真正粘住的时候，因为它与您的生活相关。</p>
      
      <h3>2. 每日复习：您的大脑健身房</h3>
      <p>真正的流利需要日常的心理努力。一个好的系统向您显示确切到期的内容，而不会给您简单的胜利只是为了让您感觉更好。它向您显示您即将忘记的单词，迫使那种理想难度，使语言终生保持。那种不舒服的感觉？那是您的大脑变得更强。</p>
      
      <h3>3. 真正注意的智能算法</h3>
      <p>最好的系统跟踪的不仅仅是正确或错误。它们观察您回忆的速度和信心。遇到单词困难？一个好的算法知道那个神经通路仍然薄弱，并安排更多练习。这不仅仅是标记某物为"已知"—这是理解您何时真正知道它，而不是何时您只是在猜测。</p>
      
      <h3>4. 准备好时进行速度练习</h3>
      <p>一旦一个词开始感觉自然，您需要练习高速检索。一些应用程序有滑动模式用于此—快速浏览您的复习，标记您知道的内容，继续。您正在训练自己立即提取单词，这正是当您试图在快速对话中跟上母语者时所需的。</p>
      
      <h2>底线</h2>
      <p>如果您把所有时间都花在看视频和点击单词库上，您会变得非常擅长看视频和点击单词库。想变得擅长说话？您必须练习检索。</p>
      
      <p>不要被错觉所迷惑。开始练习真正的主动回忆，将那个被动词汇转化为主动流利。</p>`,
  blogArticle4Title: "初学者学习新语言时犯的5大错误（以及如何避免）",
  blogArticle4Excerpt: "开始学习一门新语言是一种令人难以置信的感觉，但统计数据显示，绝大多数语言学习者在最初的30天内就放弃了。如果您想成为真正达到流利程度的那一小部分人，以下是需要避免的5大错误。",
  blogArticle4Author: "SafaCards团队",
  blogArticle4Content: `      <p>开始一门新语言感觉很棒。您有动力，有新笔记本，梦想自己在某个巴黎咖啡馆或东京寿司店轻松聊天。</p>
      
      <p>但这是残酷的真相：大多数语言学习者在30天内就放弃了。这不是关于天赋。他们只是陷入同样的五个初学者陷阱，这些陷阱会杀死动力并阻碍进步。</p>
      
      <p>想成为真正达到流利的那一小部分人？以下是需要避免的五个错误。</p>
      
      <h2>1. 没有系统的学习</h2>
      <p>大多数初学者随机学习。周一YouTube视频。周二旅行短语书。周五播客。没有系统，没有跟踪。您的大脑将所有信息视为垃圾邮件并扔掉它。</p>
      
      <p><strong>修复它：</strong>您需要一个地方存放您的所有词汇。无论您是从电影还是教科书中学习，将这些词放入间隔重复系统。您在哪里找到这个词并不重要—它进入相同的科学复习时间表。</p>
      
      <h2>2. 死记硬背的误区</h2>
      <p>学校教我们为考试死记硬背。我们认为周日的4小时等于每天20分钟。在语言学习中？这完全错了。您的大脑需要时间—和睡眠—在会话之间来建立新语言所需的实际神经通路。</p>
      
      <p><strong>修复它：</strong>采用10分钟规则。一致性每次都胜过强度。短时间的每日爆发是将单词从短期记忆转移到长期记忆的唯一方法。</p>
      
      <h2>3. 忽视幂律</h2>
      <p>初学者浪费数月学习他们永远不会使用的词。"刺猬。" "订书机。"同时，他们跳过高频词，如"然而"、"因为"、"需要"。学习最常见的1,000个词，您将理解大约80%的日常对话。</p>
      
      <p><strong>修复它：</strong>要挑剔。专注于真正出现在您想要进行的对话中的高频词汇。</p>
      
      <h2>4. 陷入被动学习</h2>
      <p>看带英文字幕的电影？睡觉时听一门语言？感觉像在学习，但这主要是浪费时间。您的大脑不会仅仅因为接近一门语言而学习。它通过被挑战而学习。</p>
      
      <p><strong>修复它：</strong>转向主动回忆。不要只是看翻译。使用迫使您从记忆中自己产生单词的工具。</p>
      
      <h2>5. 过早过度分析语法</h2>
      <p>在甚至能说"你好，我的名字是..."之前试图掌握每个复杂的语法规则？这是倦怠的配方。语法是骨架。词汇是肉。没有单词，骨架就没有支撑。</p>
      
      <p><strong>修复它：</strong>先学习短语和单词。当您在抽认卡和对话中看到模式时，语法会自然开始变得有意义。</p>
      
      <h2>构建您的系统</h2>
      <p>看，关键是找到像护栏一样工作的工具。您想要一些能阻止您犯这五个错误的东西，而不必一直思考它。</p>
      
      <h3>不再随机学习</h3>
      <p>不要只学习随机列表。寻找允许您为实际遇到的单词创建卡片的工具。读专业文章？看节目？一些系统使用AI帮助您构建与您生活相关的定制课程。这就是学习真正坚持的地方。</p>
      
      <h3>击败死记硬背陷阱</h3>
      <p>您不应该管理您的时间表。一个好的间隔重复系统告诉您每天哪些词到期。它向您显示适量的内容，防止因试图一次做太多而导致的倦怠。完全消除了决策制定。</p>
      
      <h3>掌握幂律</h3>
      <p>智能算法确保您在困难的单词上花费最多时间，在简单的东西上花费更少时间。使您的学习会话更高效。将您的精力集中在真正让您更快达到流利的词汇上，而不是浪费时间在您已经知道的东西上。</p>
      
      <h3>到处都是主动回忆</h3>
      <p>最好的工具完全建立在主动回忆上。没有简单的多选题选项。没有单词库。只有您和您的记忆。当您必须自己产生单词时，这就是您建立现实世界对话所需心理肌肉的地方。那种挣扎？那就是学习发生的地方。</p>
      
      <h2>更聪明地开始</h2>
      <p>避免这五个错误，您已经领先于90%的其他学习者。语言学习不是神秘的事情。它只是在正确的间隔使用正确的工具。</p>`,
  blogArticle5Title: "文化在语言中的作用：为什么您不能只学习词汇",
  blogArticle5Excerpt: "假设您做的一切都'正确'。您学习。您努力通过抽认卡。您记住了'你好'、'吃'、'礼物'这些词。然后您降落在那个国家，走进一家小店，说出您仔细学过的句子…柜台后面的人给您一个介于困惑和轻微警觉之间的表情。",
  blogArticle5Author: "SafaCards团队",
  blogArticle5Content: `<p>假设您做的一切都"正确"。</p>
      
      <p>您学习。您努力通过抽认卡。您记住了'你好'、'吃'、'礼物'这些词。您感到准备好了。老实说，您对自己有点自豪。</p>
      
      <p>然后您降落在那个国家，走进一家小店，说出您仔细学过的句子…柜台后面的人给您一个介于困惑和轻微警觉之间的表情。</p>
      
      <p>不是生气，确切地说。只是…不对劲。就像您踩到了一个您甚至没看到的社会地雷。</p>
      
      <p>这就是大多数语言学习者意识到一些令人恼火的事情的时刻：</p>
      
      <p>您可能知道这些词，但仍然不知道自己在做什么。</p>
      
      <p>因为语言不仅仅是词汇。它是礼仪。它是时机。它是人们在词语之间表达的意思。它是文化—融入人们问候、开玩笑、抱怨、调情、道歉、不同意以及结束对话而不让它变得奇怪的方式中。</p>
      
      <h2>单词是容易的部分（抱歉）</h2>
      <p>这里有一个简单的英语例子："你好吗？"</p>
      
      <p>我们经常说这句话。在杂货店。在工作中。对我们几乎不认识的人。大多数时候，它实际上并不意味着："请告诉我您心理状态和腰痛的真实情况。"</p>
      
      <p>它的意思是：你好。它的意思是：我注意到您了。</p>
      
      <p>现在想象您把这个完全字面的想法放到另一种文化中，在那里问个人问题是…嗯，个人的。或者问候更正式。或者预期的回答更长、更尊重，或根据人的年龄而不同。</p>
      
      <p>突然，您的"友好"话语可能听起来像是侵入性的、奇怪的亲密，或者只是社交上笨拙的。</p>
      
      <p>这就是人们说"语言和文化是相连的"时的意思。这不是什么诗意的口号。这是实用的。</p>
      
      <h2>文化潜入语言的几种方式（即使您没有注意到）</h2>
      <p><strong>方言不是可选的。</strong></p>
      <p>马德里的西班牙语与墨西哥城的西班牙语不同。不仅仅是口音—单词、俚语、听起来自然的、听起来生硬的、听起来像您从1997年的教科书学来的。巴黎的法语与魁北克的法语、葡萄牙的葡萄牙语与巴西的葡萄牙语等也是如此。</p>
      
      <p>您可以说"中性"版本，但它经常让您听起来像游客（或像翻译应用）。这没关系！但如果您的目标是"我想听起来正常"，您需要您周围的人实际使用的版本。</p>
      
      <p><strong>习语会立即让您谦逊。</strong></p>
      <p>习语是直接翻译走向死亡的地方。</p>
      
      <p>例子：在法语中，"Les carottes sont cuites"字面意思是"胡萝卜煮熟了"，但它真正意思更接近"我们完蛋了"或"结束了"。如果您逐字翻译，您会理解每个词…但仍然完全错过意思。（另外：为什么涉及胡萝卜？没人知道。别跟它较劲。）</p>
      
      <p>如果您只像学数学一样学语言—词等于词—您将总是有点在对话之外。您会得到骨架，但得不到活的东西。</p>
      
      <h2>我们在SafaCards中做的不同之处（因为这正是人们卡住的地方）</h2>
      <p>我们很早就意识到"一刀切的语言学习"有点像是幻想。人们不学"西班牙语"。他们学习他们要去的地方和想与之交谈的人的西班牙语。</p>
      
      <p>所以我们构建应用程序，将文化视为课程的一部分，而不是您读一次就忘记的随机奖励事实。</p>
      
      <p><strong>1) 特定方言学习（因为您不是搬到"通用国"）</strong></p>
      <p>当您开始一副牌时，我们不只是问"什么语言？"我们问您真正想要的是什么—地区、目标、您想要进行的对话类型。</p>
      
      <p>学习魁北克法语？很好。巴西葡萄牙语？酷。词汇和措辞会调整，所以您不会练习技术上存在但在现实生活中让当地人慢慢眨眼看您的东西。</p>
      
      <p><strong>2) 真实短语，不只是孤独的小名词</strong></p>
      <p>很多应用做单字的事情：苹果。汽车。房子。这…还好。但没有人用抽认卡片段说话。</p>
      
      <p>人们用块说话。用模式。用"您离开时说的话"或"礼貌拒绝的方式"或"在不听起来要求的情况下随意请求帮助的方式"。</p>
      
      <p>所以SafaCards专注于自然短语和完整句子，匹配人们实际说话的方式。不只是"去"，而是某人真正说"我要走了"、"我要离开了"、"我马上回来"的方式，以及每个何时合适。</p>
      
      <p>这就是您学习语言节奏的地方。还有社交规则。还有氛围。</p>
      
      <p><strong>3) 将文化负载短语视为它们真正重要性的复习</strong></p>
      <p>有些短语更难，不是因为它们长，而是因为它们承载社会重量。比如：这是礼貌的，那个太直率，这个是开玩笑，那个听起来冷淡，这个对朋友可以但对陌生人奇怪。</p>
      
      <p>我们的复习安排（基于SM2）关注什么需要您更多努力来回忆。如果一个短语很棘手—特别是习语或"社交特定"的表达—应用程序会在正确的时间把它带回来，而不是让它消失在深渊中。</p>
      
      <p><strong>4) 练习"流畅度"，这样您就不会在对话中冻结</strong></p>
      <p>您知道那个时刻，您确实知道这些词…但您的大脑仍在缓冲，因为您试图像组装IKEA家具一样组装它们？</p>
      
      <p>这就是我们试图减少的。</p>
      
      <p>快速待办模式是为了建立那种本能：滑动浏览现实、文化正常的短语，直到它们开始在您需要时自动出现。不完美。只是足够流畅，让您可以保持在对话中。</p>
      
      <h2>真正的要点：文化是让您听起来像人的东西</h2>
      <p>学习词汇可以让您通过测验。</p>
      
      <p>学习文化可以让您通过对话，而不会出现对方暂停、您能感觉到有什么不对劲的奇怪时刻。</p>
      
      <p>我们大多数人学习语言不是为了给考试监考员留下深刻印象。我们学习是因为我们想要联系：在正确的时刻笑，讲故事而不结巴，理解某人的意思而不仅仅是他们说的话。</p>
      
      <p>老实说？当您最终正确使用当地习语时—或者您以对他们来说自然的方式问候某人时—您可以在他们脸上看到。从"哦，游客"到"哦，您明白了"的小小转变。</p>
      
      <p>这就是好东西。</p>
      
      <p>所以是的，学习这些词。绝对要学。但不要停在那里。词典给您建筑材料。文化是将它变成家的东西。</p>
      
      <p>如果您想要感觉真实的流利，瞄准归属—而不是完美。</p>`,
  blogArticle6Title: "为什么在语言学习中一致性胜过强度",
  blogArticle6Excerpt: "大多数人放弃一门语言并不是因为它'太难'。他们放弃是因为他们陷入了一个超级常见的模式：周末冲刺。您知道那个。您在周六做一个五小时的学习马拉松，感觉非常有成效，也许甚至有点自鸣得意…然后生活发生了。",
  blogArticle6Author: "SafaCards团队",
  blogArticle6Content: `<p>大多数人放弃一门语言并不是因为它"太难"。</p>
      
      <p>他们放弃是因为他们陷入了一个超级常见的模式：周末冲刺。</p>
      
      <p>您知道那个。您在周六做一个五小时的学习马拉松，感觉非常有成效，也许甚至有点自鸣得意…然后生活发生了。您直到下个周末才再次接触这门语言，那时您花第一个小时重新学习上次"学过的"一半内容。</p>
      
      <p>不是您不自律。而是这种方法基本上就是为了让您沮丧而设计的。</p>
      
      <p>如果您想以真正持久的方式变得流利，一致性会赢。每次都是。</p>
      
      <h2>无聊的真相：小的日常努力是作弊代码</h2>
      <p>有一个流行的想法叫做"1%规则"—基本点是微小的改进会以让您惊讶的方式累积。在语言学习中，它看起来像这样：</p>
      
      <p>每天15分钟几乎每次都胜过每周一次的巨大会话。</p>
      
      <p>为什么？因为您的大脑不像一个可以塞满信息直到装满的手提箱那样工作。它更像湿水泥：您铺一点，然后需要时间让它凝固。这种凝固发生在会话之间的间隙中—特别是当您睡觉时。</p>
      
      <p>所以即使感觉您做得"更少"，日常练习给您的大脑更多机会锁定事物。</p>
      
      <h2>强度有一个隐藏成本：倦怠</h2>
      <p>大的学习计划在您有动力时听起来很棒。"我每天晚上要学习两个小时。"喜欢这种雄心。</p>
      
      <p>但两个小时是很多。很容易跳过一次。然后您跳过两次。然后整个习惯崩溃，您开始感到内疚，这让您更加避免它。突然语言不再有趣了—它是您待办事项清单上那个沉重的东西。</p>
      
      <p>短会话没有那种相同的情感重量。</p>
      
      <p>说服自己跳过10分钟比说服自己投入两个小时要困难得多。</p>
      
      <p>还有另一个隐蔽的好处：当您的目标很小（"我今天要学五个单词"或"我要做一个复习会话"）时，您开始与语言建立一种感觉可行的关系。不戏剧性。不累人。只是…正常。</p>
      
      <h2>保持一致的三种简单方法（即使您很忙或很累）</h2>
      <p><strong>1) 将它附加到您已经在做的事情上。</strong></p>
      <p>不要依赖动机。将语言时间绑定到已经自动的例行公事：</p>
      
      <ul>
      <li>早上的咖啡</li>
      <li>您的通勤</li>
      <li>午休</li>
      <li>刷牙（是的，真的—两分钟会累积）</li>
      </ul>
      
      <p>如果它粘在现有习惯上，它就不再感觉像"又一件事"。</p>
      
      <p><strong>2) 在低能量日，选择输入而不是学习。</strong></p>
      <p>有些日子您不想练习语法。好的。不要做。</p>
      
      <p>听播客。放音乐。看一个短视频。读几行简单的东西。让您的大脑保持与声音和模式的接触仍然算数。它保持语言"温暖"。</p>
      
      <p><strong>3) 使用间隔重复，这样您就不会随机复习。</strong></p>
      <p>一致性的一大部分是让练习感觉高效。间隔重复有帮助，因为它向您显示您最可能忘记什么，就在它重要的时候，而不是让您一直复习所有内容。</p>
      
      <p>这就是SM2风格调度的想法（这是SafaCards如何构建复习的重要组成部分）。</p>
      
      <h2>"海绵"问题（为什么死记硬背会泄漏）</h2>
      <p>把您的大脑想象成一块海绵。</p>
      
      <p>如果您一次将一整桶水倒在干海绵上，很多水只是从侧面溢出。但如果您缓慢而稳定地滴水，海绵实际上会吸收它。</p>
      
      <p>这基本上就是您死记硬背时发生的事情。</p>
      
      <p>您的注意力和记忆有一个限制。一旦您达到它—通常比人们想要承认的更快—额外的时间不会给您更多学习。它们给您更多疲劳。然后您将语言与疲惫联系起来，这让您避免它，这让您落后，这让下一次会话感觉更糟。</p>
      
      <p>它变成这个循环：</p>
      <p>死记硬背 → 忘记 → 感觉糟糕 → 更努力地死记硬背 → 再次忘记</p>
      
      <p>日常接触打破循环。它给您的大脑重复的机会来加强相同的路径，而不会烧坏自己。</p>
      
      <h2>真正的长期技巧：让它成为您是谁的一部分</h2>
      <p>人们喜欢谈论"有天赋的多语言者"，好像他们有神奇的语言DNA。</p>
      
      <p>大多数时候，他们没有。他们拥有的是不那么令人兴奋但更强大的东西：身份。</p>
      
      <p>他们不是在"做一个语言项目"。他们是那种每天与语言互动的人，即使很小。</p>
      
      <p>这很重要，因为当动机下降时（它会），身份让您继续前进。在您不想做的日子里，做五分钟复习与其说是关于词汇，不如说是关于在您头脑中保持连胜：</p>
      
      <p>"我是一个会露面的人。"</p>
      
      <p>这就是您如何避免语言学习墓地—废弃的教科书，布满灰尘的应用程序，"我下个月再开始"的循环。</p>
      
      <h2>相信过程（即使感觉缓慢）</h2>
      <p>如果您每天只做10–15分钟，可能会感觉您做得不够。但语言进步不是大声的。它是隐蔽的。</p>
      
      <p>有一天您意识到您理解了一首歌中的一行，没有翻译。或者您在视频中捕捉到一个短语。或者一个句子从您嘴里出来，而您没有逐块构建它。</p>
      
      <p>这些时刻来自无聊的日子—小的、一致的存款。</p>
      
      <p>所以停止等待永远不会出现的完美三小时学习窗口。做今天的十分钟。然后明天再做一次。</p>
      
      <p>流利不是短跑。这是一次长途步行，您被允许慢慢移动…只要您不停止。</p>`,
  blogArticle7Title: "神经可塑性与语言：成年人真的能学会一门新语言吗？",
  blogArticle7Excerpt: "如果你曾经告诉别人你在成年后学习一门语言，你可能在30秒内听到过类似的话：“唉，我希望我小时候就学了。成年人真的不能像孩子那样学习语言。”",
  blogArticle7Author: "SafaCards团队",
  blogArticle7Content: `<p>如果你曾经告诉别人你在成年后学习一门语言，你可能在30秒内听到过类似的话：</p>

      <p>“唉，我希望我小时候就学了。成年人真的不能像孩子那样学习语言。”</p>

      <p>有时这话说得很委婉。有时这被当作科学事实来说。有时这来自那个自从九年级西班牙语课后就没试过，并且仍然对“虚拟语气”这个词感到深受伤害的人。</p>

      <p>但事实是：这种想法被夸大了。是的，孩子们有一些不公平的优势。不，你的成年大脑不是化石。你没有“太老”。你也不缺“那个基因”。你也绝对没有注定永远要用慢动作点咖啡。</p>

      <p>现代神经科学有一个相当令人鼓舞的信息：你的大脑可以持续改变——在任何年龄。这种能力有一个名字：神经可塑性。这就是为什么成年人学习语言的效果比人们想象的要好得多。</p>

      <h2>神经可塑性，没有教科书般的氛围</h2>
      <p>神经可塑性只是一个花哨的说法：你的大脑可以自我重新连接。</p>

      <p>它建立新的连接，加强你使用的那些，并让“未使用”的东西稍微消退。（这也是为什么你会在两周内忘记一个密码，但却记得2009年的歌词。很粗鲁，但很一致。）</p>

      <p>这是我知道的最简单的想象方式：</p>

      <p>你的大脑就像一片有小径的田野。</p>
      <p>每次你使用一个新单词或短语，你就在踩出一条新路。</p>
      <p>你走得越多，它就越清晰。</p>
      <p>如果你停止走它，草就会长回来。不是立刻——只是足以让它开始再次感到陌生。</p>

      <p>孩子们开始时有大量的开阔地。成年人已经建好了高速公路——你的母语是主要的。所以当你开始一门新语言时，你的大脑自然会试图通过熟悉的道路带你回去。</p>

      <p>这并不意味着你不能建立新路。这只是意味着你可能需要在它们不再感觉像是在灌木丛中开路之前，多走几次。</p>

      <h2>“但孩子们更好……”——是的，在某种特定方式上</h2>
      <p>孩子们在不尝试的情况下习得语言是惊人的。把他们放在一个环境中，他们吸收声音和节奏就像呼吸一样。</p>

      <p>成年人通常没有那种“毫不费力”的感觉。这就是人们气馁的地方。</p>

      <p>但成年人有一套不同的优势，而且它们比大多数人意识到的更重要：</p>

      <p><strong>1) 成年人可以理解模式。</strong></p>
      <p>孩子们主要通过模仿学习。成年人可以看一个句子说，“噢，所以动词放在这里，”或者“这就像英语，只是反过来了。”这种比较和推理的能力基本上是一个作弊码。</p>

      <p><strong>2) 成年人可以有目的地学习。</strong></p>
      <p>一个孩子可能会获得数千小时的被动接触。成年人可以用更少的时间取得很大的进步，因为他们可以真正专注。即使每天10-20分钟，如果结构合理，也会比人们预期的走得更远。</p>

      <p><strong>3) 成年人有元认知（又名：你了解你自己）。</strong></p>
      <p>你知道你什么时候累了。你知道你什么时候敏锐。你知道什么让你记住东西——写下来，听它，在句子中使用它，不管是什么。孩子们不管理他们的学习。成年人可以。</p>

      <p>所以当成年人在语言上“失败”时，通常不是因为大脑做不到。而是因为方法混乱，太不频繁，或者老实说……无聊。</p>

      <h2>真正绊倒成年人的事情：被卡住</h2>
      <p>人们谈论一种叫做化石化的现象。听起来很戏剧化，但这基本上是你达到“足够好”然后停止推动时发生的事情。</p>

      <p>你学会了如何生存：</p>
      <ul>
      <li>点菜</li>
      <li>介绍自己</li>
      <li>问厕所在哪里（永恒的经典）</li>
      </ul>

      <p>……然后你永远重复同样的安全短语。这感觉很舒服，但这不是你进步的方式。</p>

      <p>当你继续给大脑混合以下内容时，它保持灵活：</p>
      <ul>
      <li>新鲜感（新东西）</li>
      <li>挑战（一点不适）</li>
      <li>重复接触（让它留下来）</li>
      </ul>

      <p>那是最佳击球点。不是无休止的死记硬背。不是无休止的舒适区短语。持续的“新，但可行”的滴灌。</p>

      <h2>SafaCards 如何为成年人的大脑（和时间表）设计</h2>
      <p>我们将 SafaCards 建立在一个相当基本的事实之上：成年人失败不是因为他们无能。他们失败是因为他们忙，累，并且试图用不符合记忆工作方式的方法去学习。</p>

      <p>所以这是我们关注的：</p>

      <p><strong>1) 真正让东西留下来的复习时间</strong></p>
      <p>如果你在一个单词刚开始消退时复习它，你的大脑会收到信息：保留这个。</p>
      <p>这就是为什么间隔重复有效。SafaCards 使用 SM2 风格的调度（带有加权）来带回你可能忘记的东西——而不是把你淹没在不断的简单卡片复习中。</p>
      <p>你不仅仅是“学得更多”。你在重要的时刻学习。</p>

      <p><strong>2) 感觉像你生活的卡片</strong></p>
      <p>你的大脑很挑剔。它记得感觉相关的东西。</p>
      <p>现成的牌组很好，但它们通常感觉很通用。就像你在一个你从不去火车站的生活中学习讨论“火车站”。</p>
<p>使用 AI 卡片生成器，你可以围绕你的兴趣和日常制作卡片——工作词汇，旅行情境，你的爱好，你看的节目，你真正吃的食物。那种个人相关性很重要。记住“我走了”比“松鼠在桌子底下”容易得多。</p>

      <p><strong>3) 每日复习，这样你就不用计划</strong></p>
      <p>这部分被低估了：成年人不想把他们有限的学习时间花在决定学什么上。</p>
      <p>每日复习模式消除了“现在怎么办？”的问题。你打开应用程序，它显示到期内容，你做这节课，继续前进。这种频率可以防止新的神经通路长满杂草。</p>

      <p><strong>4) 快速演练以提高速度（因为流利主要是速度）</strong></p>
      <p>很多知道单词，但无法足够快地在对话中使用它们。</p>
      <p>快速任务旨在建立那种“自动”回忆。目标不是坐在那里苦思冥想；目标是让你的大脑说，哦是的，那个，没有戏剧性。</p>

      <h2>所以……成年人能学会一门语言吗？</h2>
      <p>是的。句号。</p>

      <p>这会感觉和孩子学习完全一样吗？可能不会。孩子们吸收；成年人建造。但建造并不更差——尤其是当你拥有正确的工具并坚持出现时。</p>

      <p>老实说？成年人的优势是：你选择了它。你是有意去做的。这很重要。</p>

      <p>你的大脑并没有关门歇业。它只是很忙。给它一个与记忆合作（而不是对抗）的系统，它会做大脑最擅长的事情：适应。</p>

      <p>即使你从30岁开始。或45岁。或62岁。<br />
      即使你累了。<br />
      即使你某些天只能挤出五分钟。</p>

      <p>五分钟仍然保持道路畅通。这就是开始的方式。</p>`,
  blogArticle8Title: "抽认卡 vs. 游戏化：哪种方法能让您更快流利？",
  blogArticle8Excerpt: "如果您决定在2025年学习一门语言，您可能遇到了两种截然不同的应用风格：“这感觉像游戏”的应用和“这感觉像学习”的应用。两者都会告诉您它们能通向流利。但它们对您大脑的作用并不相同。",
  blogArticle8Author: "SafaCards团队",
  blogArticle8Content: `<p>如果您决定在2025年学习一门语言，您可能遇到了两种截然不同的应用风格：</p>

      <p>“这感觉像游戏”的应用（连续记录！彩纸屑！小声音！）</p>

      <p>“这感觉像学习”的应用（抽认卡、复习、间隔重复，整个严肃的设置）</p>

      <p>两者都会告诉您它们能通向流利。两者都有数百万用户。而且两者都可能有用。</p>

      <p>但它们对您大脑的作用并不相同。</p>

      <p>一种主要训练您在答案摆在您面前时识别它们。<br />
      另一种训练您在没有任何帮助时从脑海中提取单词。</p>

      <p>如果您在乎真正的口语——比如点餐、交朋友、不在句子中间卡住——这种区别非常重要。</p>

      <h2>“游戏”方法：有趣……但通常建立在识别之上</h2>
      <p>游戏化应用非常擅长让人们回来。它们知道如何让您不断点击：</p>

      <ul>
      <li>您不想打破的连续记录</li>
      <li>等级和联赛</li>
      <li>奖励、徽章、每日目标</li>
      <li>让您的大脑说“耶”的可爱动画</li>
      </ul>

      <p>老实说？那些东西很有效。对于建立习惯，游戏化很强大。</p>

      <p>问题在于这些应用大部分时间要求您做什么：</p>

      <ul>
      <li>从列表中选择正确的单词</li>
      <li>将声音与图片匹配</li>
      <li>在大部分句子已经构建好的情况下填空</li>
      <li>带有重度提示的翻译</li>
      </ul>

      <p>这就是识别。您的大脑基本上是在说，“哪个看起来眼熟？”而答案通常就在屏幕上。</p>

      <p>对绝对初学者很有好。对建立信心很好。<br />
      但当您处于真实对话中，没有像多选题那样飘在空中的词汇库时，这并不总是很好。</p>

      <p>这就是为什么人们会说，“我已经用了这个应用一年了，”然后紧接着说，“但我仍然不会说话。”</p>

      <p>并不是他们什么都没学到。而是他们练习了错误的提取类型。</p>

      <h2>“抽认卡”方法：不那么可爱，但在口语方面更有效</h2>
      <p>抽认卡——特别是当它们与间隔重复配对时——是相反的风格。</p>

      <p>它们不试图娱乐您。它们试图让您的大脑工作。</p>

      <p>使用抽认卡，通常没有列表可供选择。没有图片可点击。没有“差不多”的提示。它只是：</p>

      <p>这是提示。答案是什么？</p>

      <p>这就是回忆（或生产）。这更难。这也是您在现实生活中需要的相同技能，因为当有人在咖啡馆问您问题时，正确的动词不会带着闪闪发光的小动画从右边滑入。您要么提取它……要么没有。</p>

      <p>所以是的，抽认卡可能感觉更像是一种锻炼而不是游戏。<br />
      但这种“努力”才是重点。那种挣扎是记忆变强的地方。</p>

      <h2>好消息：您实际上不必选择其中之一</h2>
      <p>这是我们要相信的：最好的设置结合了现代应用的粘性（日常习惯、清晰的进度、快速的会话）和间隔重复及主动回忆的学习能力。</p>

      <p>这就是 SafaCards 旨在填补的空白。</p>

      <h3>1) 没有您必须苦苦挣扎的固定课程</h3>
      <p>许多游戏化应用迫使您走一条固定路径。您还不能学习您关心的内容，因为首先您必须掌握“男孩吃苹果”的47种变体。</p>

      <p>使用 SafaCards 的 AI 抽认卡生成器，您可以围绕您的现实生活构建：</p>

      <ul>
      <li>医生？生成医学词汇和患者短语</li>
      <li>厨师？专注于厨房语言</li>
      <li>即将旅行？围绕机场、酒店和闲聊建立一副牌</li>
      <li>为了约会、工作、家庭、学校学习？同样的想法</li>
      </ul>

      <p>您不会被困在别人的课程中。您在设计自己的课程。</p>

      <h3>2) 真正高效的复习时间</h3>
      <p>游戏化应用的一个隐蔽缺点：您可能会花费大量时间“复习”您已经知道的东西……因为应用想让您保持参与，让您不断点击，保持连续记录。</p>

      <p>SafaCards 的加权 SM2 方法旨在稍微少一点情感支持，多一点实用性：它优先考虑您快要忘记的内容和您挣扎的内容，所以您的时间花在真正重要的地方。</p>

      <p>简单来说：您在短时间内完成了更多真正的学习。</p>

      <h3>3) 感觉令人满意而不肤浅的每日复习</h3>
      <p>我们保留了现代应用最好的部分：每日“待办事项清单”的感觉。</p>

      <p>您打开 SafaCards，获得一组清晰的复习任务来完成。您会获得同样的进步感——“今天完成了”——但您所做的工作是主动回忆，而不仅仅是点击熟悉的答案。</p>

      <h3>4) 快速滑动以获得“游戏”感觉（减去空热量）</h3>
      <p>如果您喜欢速度，我们也有。像“复习所有到期单词”这样的复习模式让您快速浏览您已经学过的卡片，保持高频词汇新鲜，而不会将您拖入无休止的婴儿级练习。</p>

      <h2>那么裁决是什么？</h2>
      <p>如果您的主要目标是“我想要一个感觉有趣并让我娱乐的应用”，那么游戏化路径应用可能很棒——尤其是在开始时。</p>

      <p>但如果您的目标是“我想真正说这门语言”，您需要迫使您产出语言而不仅仅是识别它的练习。</p>

      <p>这就是为什么抽认卡 + 间隔重复在流利度方面往往获胜。它们训练您在对话中使用的确切技能：在压力下从脑海中提取单词和短语。</p>

      <p>如果您将其与现代工具相结合——您真正关心的自定义牌组、智能调度、日常习惯——您不仅仅是感觉自己在学习。</p>

      <p>您开始真正使用这门语言。</p>`,
  blogArticle9Title: "一天中学习语言的最佳时间（根据科学）",
  blogArticle9Excerpt: "您可能听过人们争论是'早起的人'还是'夜猫子'，好像这是个性特征。但当您试图将几千个外语单词塞进脑袋时，时间不仅仅是关于您的感觉—而是关于战术生物学。",
  blogArticle9Author: "SafaCards团队",
  blogArticle9Content: `<p>您可能听过人们争论是"早起的人"还是"夜猫子"，好像这是个性特征。但当您试图将几千个外语单词塞进脑袋时，时间不仅仅是关于您的感觉—而是关于战术生物学。科学对您的大脑何时真正开放工作、何时实际上关闭维护有一些相当直率的说法。</p>
      
      <p>您的大脑不会从醒来那一刻到晚上崩溃时都以100%的容量运行。它更像是一块电池，根据特定的认知功能窗口达到峰值和下降。如果您能弄清楚您的注意力何时真正启动，您就可以停止"苦学"并开始真正记住您所学的内容。</p>
      
      <h2>早起的理由</h2>
      <p>大多数认知研究指出早上6点到10点之间有一个"黄金窗口"。听着，我知道如果您不是早起的人，这是个烦人的消息，但化学很难反驳。</p>
      
      <p>经过一整夜的睡眠，您的大脑已经完成了它的夜间"清理工作"（巩固昨天的记忆）。您的前额叶皮层—处理高级注意力的部分—是新鲜的。您还没有被五十条Slack通知、压力邮件或仅仅存在于现代世界所带来的"决策疲劳"所消耗。</p>
      
      <p>当您的头脑安静时，新词汇实际上会粘住。研究表明，早晨学习者往往有更好的长期保留率，仅仅因为他们的大脑不需要与到下午4点积累的心理"静电"作斗争。</p>
      
      <h2>可怕的下午低谷</h2>
      <p>我们都感受过。在下午2点到4点之间的某个时候，您的身体会达到科学家所说的"午餐后低谷"。您的系统忙于处理午餐，您的血糖在波动，您的昼夜节律自然下降。老实说？这是尝试掌握复杂新语法规则的绝对最糟糕时间。</p>
      
      <p>如果这是您唯一的空闲时间，不要试图爬一座山。与其学习新东西，不如使用这种"低功耗模式"进行低风险的复习。翻阅一些您已经知道的抽认卡，听您目标语言的播客，或者只是在镜子里练习发音。您让引擎空转而不烧坏您的心理电池。</p>
      
      <h2>"夜猫子"高峰和睡眠三明治</h2>
      <p>对于阅读本文的夜猫子来说，通常在晚上7点到9点之间会有第二个高峰。如果您发现自己突然警觉，而其他人都准备休息，这就是您发光的时候。</p>
      
      <p>但这里有一个秘密武器叫做睡眠三明治。研究表明，如果您在睡觉前学习，然后获得高质量的夜间睡眠，您的大脑会在您无意识时"烘烤"这些信息。睡眠本质上是您记忆的"保存按钮"。诀窍是避免熬夜太晚，以至于您削减了实际休息—如果您筋疲力尽，保留就不会发生。学习45分钟，然后上床睡觉。</p>
      
      <h2>忘记"完美"时间—找到您的时间</h2>
      <p>虽然早上8点的窗口在"统计上"更好，但您自己的内部时钟每次都胜过教科书。如果您强迫自己在早上8点学习，但您的大脑实际上直到中午才"醒来"，您只是在浪费精力。</p>
      
      <p>找到您高峰的最佳方法？像科学家一样实验。尝试一周的早晨会话和一周的夜间会话。跟踪您第二天的"回忆"。您的身体会非常清楚地告诉您它何时真正在听，何时只是在忽略您。</p>
      
      <h2>SafaCards如何适应混乱</h2>
      <p>我们构建SafaCards不是为了强迫您进入早上6点的例行公事。我们构建它是为了成为"变色龙"。无论您是在火车上复习的通勤者，还是在睡前练习动词的夜猫子，每日复习模式都会为您处理时间安排。</p>
      
      <p>目标不是找到某个神话般的"完美"时刻。而是建立一个仪式。您的大脑喜欢模式。如果您每天在同一时间学习，您的头脑最终会开始为该会话"预热"。它使学习感觉不那么像苦差事，而更像是一种反射。</p>
      
      <h2>底线</h2>
      <p>科学倾向于早晨，但生活倾向于对您来说真正可能的事情。下午3点的10分钟会话比永远不会发生的"完美"一小时会话要好得多，因为您太累了无法开始。</p>
      
      <p>使用数据作为指导，但倾听您的直觉。保护您的高峰能量窗口，在低谷时给自己一些放松，记住：流利不是关于时钟。它是关于日复一日地出现，直到这些词最终感觉像是属于您的。</p>`,
  blogArticle10Title: "平台期问题：为什么您停止进步（以及如何突破）",
  blogArticle10Excerpt: "我仍然记得当我第一次开始学习第二语言时的感觉。每一天都带来某种胜利。然后……它停止了。大约四个月后，动力消失了。这就是平台期。",
  blogArticle10Author: "SafaCards团队",
  blogArticle10Content: `<p>我仍然记得当我第一次开始学习第二语言时的感觉。老实说？感觉太棒了。每一天都带来某种胜利。我学会了说一些基本的东西，比如"洗手间在哪里？"或"我想要一杯啤酒，"突然我觉得自己势不可挡。我走来走去想，哇，我现在基本上流利了。</p>
      
      <p>进步是明显的。有形的。你可以感觉到它在实时发生，那种感觉是令人上瘾的。</p>
      
      <p>然后……它停止了。</p>
      
      <p>大约四个月后，动力消失了。我仍然在做所有"正确"的事情。我坚持我的抽认卡。我听播客。我尽可能练习。但与其感觉更聪明，我感觉卡住了。就像我尽可能用力推，但哪里也去不了—在泥里空转。</p>
      
      <p>这就是平台期。</p>
      
      <p>如果你现在就在那里，我不会粉饰它：这很痛苦。这很无聊。这很令人沮丧。这正是大多数人放弃并告诉自己他们"就是不擅长语言"的地方。</p>
      
      <p>但大多数人没有意识到的是：平台期不是你停止学习的标志。它是你的大脑已经从容易的东西转向，现在正在做繁重工作的标志。</p>
      
      <p>你已经摘了低垂的果实。明显的词汇。快速的胜利。现在你的大脑正在重新连接自己，以实现真正的、功能性的流利—而这个过程主要是看不见的。</p>
      
      <h2>为什么"墙"实际上是一件好事</h2>
      <p>想想建造房子。框架很快立起来。仅仅几天，它看起来就像真东西了。人们开车经过说，"哇，那建得真快。"</p>
      
      <p>然后……几个月似乎什么都没发生。</p>
      
      <p>但当然，事情正在发生。它们只是发生在墙后面。管道。电线。 insulation。所有那些不光彩的、看不见的工作，实际上让房子可以居住。</p>
      
      <p>这正是平台期期间你大脑中发生的事情。</p>
      
      <p>你的大脑正在将单词和结构从短期记忆—"我为练习记住了这个"区域—转移到长期直觉—"我可以不假思索地说这个"区域。你感觉不到这个过程的发生，所以感觉像失败。它不是。这是巩固。</p>
      
      <h2>你实际上陷入了哪个困境？</h2>
      <p>人们在平台期犯的最大错误是试图通过做更多相同的事情来修复它。这几乎从来不起作用。你必须弄清楚你为什么卡住了。</p>
      
      <p>大多数平台期属于以下模式之一：</p>
      
      <h3>1. "安全"陷阱</h3>
      <p>你已经足够好到可以生存了。你可以交流。人们理解你。正因为如此，你的大脑停止试图精确。你继续犯同样的语法错误，因为……嗯，它仍然有效。马虎没有真正的惩罚。</p>
      
      <p><strong>修复方法：</strong>你需要再次让事情变得不舒服。如果你习惯点咖啡，尝试解释一个复杂的电影情节或为一个观点辩护。把自己放在"足够好"不足以传达观点的情境中。</p>
      
      <h3>2. 词汇天花板</h3>
      <p>你知道最常见的单词，但一切都听起来平淡。你感觉卡在用"好"、"坏"或"东西"来形容一切。你知道你想说什么，但你没有细微差别来说它。</p>
      
      <p><strong>修复方法：</strong>停止死记硬背通用单词列表。它们令人疲惫且容易忘记。相反，学习真正属于你生活的单词。如果你喜欢烹饪，学习像"炒"或"皮屑"这样的单词。如果你对科技感兴趣，学习你实际会使用的行话。相关的词汇会粘住，因为你的大脑已经关心它了。</p>
      
      <p>这正是为什么我们在SafaCards中构建了自定义词汇生成—这样你就不会卡在记忆"卷笔刀"这个词上，而你十年都没用过它了。</p>
      
      <h3>3. 心理滞后</h3>
      <p>你仍然在翻译一切。你听到一个句子，把它转换成英语，想一个回应，然后试图把它翻译回来。当你准备好说话时，时机已经过去了。</p>
      
      <p><strong>修复方法：</strong>放弃完美理解。说真的。打开一个母语播客、广播电台或电视节目，让它播放—即使你只抓住片段。你正在训练你的大脑识别节奏、韵律和模式，而不是个别的词典定义。</p>
      
      <h2>如何真正突破</h2>
      <p>真正的进步来自破坏。如果你几个月来一直使用相同的应用程序、相同的例行程序、相同的材料，你的大脑处于自动驾驶状态—而自动驾驶会扼杀成长。</p>
      
      <p>改变一些东西。任何东西。</p>
      
      <p>在SafaCards，这就是为什么我们构建了复习最弱单词功能。大多数应用程序旨在让你感觉良好，所以它们不断向你展示你已经知道的东西。这感觉很有成效，但这是一个陷阱。成长发生在你挣扎的地方。</p>
      
      <p>专注于薄弱点更难。它不那么舒适。它也是前进的最快方式。</p>
      
      <h2>底线</h2>
      <p>平台期是不可避免的。你会在中级阶段遇到一个，你可能在真正流利之前还会遇到另一个。变得流利的人和放弃的人之间唯一的真正区别是：流利的人愿意与挫折共处并继续前进。</p>
      
      <p>你不需要完美。你只需要比昨天稍微好一点。</p>
      
      <p>好奇是什么真正阻碍了你？用我们的抽认卡模式复习你最弱的单词，让我们一起解决困难的东西。</p>`,
  blogArticle11Title: "当您没有人可以交谈时如何练习口语",
  blogArticle11Excerpt: "语言学习中的最大谎言？您需要对话伙伴。以下是如何独自建立口语技能—从跟读到自我叙述，再到用目标语言思考。",
  blogArticle11Author: "SafaCards团队",
  blogArticle11Content: `<p>让我们说实话：语言世界中最大的谎言是您需要对话伙伴才能说好。这是完美的借口，不是吗？"我无法练习，因为我不认识任何母语者，"或者"我太忙了，找不到导师。"这感觉像是保持沉默的正当理由。</p>
      
      <p>但问题是—等待伙伴就像在开始做俯卧撑之前等待健身伙伴。您只是在拖延不可避免的工作。</p>
      
      <p>实际上，我见过的一些最令人印象深刻的说话者90%的训练都是在卧室里独自完成的。他们不是从高风险的咖啡约会开始的；他们从和植物说话开始。如果您害羞、住在偏远地方，或者只是时间表很奇怪，这实际上是您的秘密优势。您可以在不担心在别人面前看起来像白痴的情况下建立说话的肌肉记忆。</p>
      
      <h2>"回声"技巧（跟读）</h2>
      <p>如果您没听说过跟读，一开始听起来可能有点奇怪。您找到母语者的片段—播客、电影场景，随便什么—然后尝试成为他们的影子。您在他们说话的同时完全重复他们说的话。</p>
      
      <p>您不仅仅是在寻找单词。您在寻找"感觉"。如果说话者听起来无聊，您听起来也无聊。如果他们拉长元音或吞掉句尾，您也这样做。这不是关于词汇；这是关于身体训练。您的口腔肌肉不习惯发出这些声音。跟读是迫使您的舌头和下巴适应新节奏的健身房训练。十分钟的跟读比一小时的默读更累。</p>
      
      <h2>停止思考，开始叙述</h2>
      <p>这是您必须投入"疯狂"能量的地方。您需要像您是一档非常无聊的真人秀明星一样叙述您的生活。</p>
      
      <p>当您做早餐时，说出来。"好的，我在打开冰箱。牛奶在哪里？啊，在那里。我把它倒进碗里。"</p>
      
      <p>听起来很荒谬，但尝试五分钟，您几乎立即就会碰壁。您会意识到您知道"牛奶"这个词，但完全不知道如何说"倒"或"冰箱"。这是找到您"现实生活"词汇空白的最佳方法。在您独自在厨房时意识到您不知道"钥匙"这个词，比您真正试图向当地人讲故事时好得多。</p>
      
      <h2>令人尴尬的语音备忘录</h2>
      <p>我们都讨厌自己声音的声音。这是普遍的。但如果您想在没有老师的情况下变得更好，您手机的录音机是您唯一诚实的朋友。</p>
      
      <p>试试"每周回顾"。录制自己三分钟谈论您的一天。没有脚本，没有准备。只是说话。然后—这是困难的部分—听它。您会听到说话时从未注意到的事情。也许您每三个词就说"嗯"，或者您的语调听起来平淡。您不需要语言学家告诉您某些东西听起来"不对"；您的耳朵已经训练有素，能够识别语言应该听起来的样子。您只需要客观地听到自己。</p>
      
      <h2>大声朗读（带感情）</h2>
      <p>大多数人默读。这对信息来说很好，但对您的嘴巴来说没用。</p>
      
      <p>每当您阅读目标语言的故事或新闻文章时，请全音量朗读。想象您是一个演员在进行戏剧表演。这迫使您处理大脑通常忽略的单词之间的棘手过渡。如果您在一个句子上绊倒，读它五遍直到感觉流畅。您正在在您的眼睛和声带之间建立桥梁。</p>
      
      <h2>杀死您脑中的翻译器</h2>
      <p>大多数人听起来"生硬"的原因是因为他们在脑海中做三重跳：听到外语单词 -> 翻译成英语 -> 用英语思考答案 -> 翻译回外语单词 -> 说话。</p>
      
      <p>太慢了。您必须从循环中切断英语。</p>
      
      <p>从在脑海中标记事物开始。当您看到一只狗时，不要想"狗 -> Perro"。只是看到动物并想"Perro"。最终，尝试用该语言与自己进行内部争论。如果您能用该语言思考，当您真正需要它们时，单词就会在您的舌尖上。您不会"构建"句子；您只是让它们出来。</p>
      
      <h2>技术是工具，不是拐杖</h2>
      <p>我们生活在一个AI对话伙伴和专门的语言学习应用程序实际上可以推动您的时代。使用句子练习功能来练习困难的东西。使用AI生成器创建您真正会遇到的奇怪场景。这些工具是让您为现实世界做好准备的训练轮。</p>
      
      <p>但请记住：技术是为了让您说话。不要只是点击屏幕。说每个词。每次。大声说出来。这就是肌肉记忆发挥作用的地方。</p>
      
      <h2>底线</h2>
      <p>流利是一项身体技能，不仅仅是心理技能。婴儿不是通过研究语法书来学习说话的；他们通过发出声音直到这些声音开始产生结果来学习。</p>
      
      <p>您不需要伙伴就可以开始发出这些声音。和您的狗说话。和您的倒影说话。和播客上的人说话。第一周感觉尴尬，当然。但那种尴尬正是进步发生的地方。当您真正与母语者坐下来时，您不会害怕—您会已经热身好了。</p>`,
  blogArticle12Title: "您大脑用来记忆事物的秘密地图（以及为什么位置可能正在破坏您的语言学习）",
  blogArticle12Excerpt: "您知道走进房间却忘记为什么在那里的那一刻吗？那是您的大脑在揭示一些重要的事情：记忆与地点相关。如果您正在学习语言，这种看不见的联系可能会破坏您的进步。",
  blogArticle12Author: "SafaCards团队",
  blogArticle12Content: `<p>您知道走进房间时目的明确…然后立即忘记为什么在那里的那一刻吗？</p>
      
      <p>您站着不动。您扫描房间。什么都没有。</p>
      
      <p>然后您走回原来的地方 — 突然想起来了。</p>
      
      <p>对了。剪刀。</p>
      
      <p>这种微小的日常烦恼实际上是您的大脑在揭示一些重要的事情：记忆与地点相关。</p>
      
      <p>如果您正在学习语言，记忆和环境之间的这种看不见的联系可能是您的单词在真正需要时消失的原因。</p>
      
      <h2>您的大脑不像您想的那样存储信息</h2>
      <p>我们大多数人把记忆当作数字文件系统。学习一个单词。保存它。在任何地方访问它。</p>
      
      <p>您的大脑不是这样工作的。</p>
      
      <p>您的大脑更像一个古老、稍微混乱的图书馆。它不仅仅记住一个单词是什么 — 它记住您在哪里，您的感受，您听到什么，以及您学习时身体在做什么。</p>
      
      <p>改变环境，大脑有时会失去路径。</p>
      
      <p>这被称为情境依赖记忆，一旦您注意到它，您会到处看到它。</p>
      
      <h2>证明这不在您脑海中的水下研究</h2>
      <p>回到1970年代，研究人员进行了一项潜水员实验，至今仍让心理学家微笑。</p>
      
      <p>潜水员在两个地方记忆单词列表：</p>
      
      <ul>
        <li>一些在水下</li>
        <li>一些坐在海滩上</li>
      </ul>
      
      <p>转折点是：</p>
      
      <p>潜水员在水下时最记得水下单词。海滩单词在海滩上很容易回忆起来…在海滩上。</p>
      
      <p>交换环境，记忆崩溃了。</p>
      
      <p>单词没有消失。访问消失了。</p>
      
      <p>您的大脑悄悄地将这些记忆与压力、声音、温度和身体感觉联系在一起。</p>
      
      <p>现在想想大多数人如何学习语言。</p>
      
      <p>同一把椅子。</p>
      <p>同一张桌子。</p>
      <p>同一个安静的房间。</p>
      <p>同一杯咖啡。</p>
      
      <p>您在家里感觉流利 — 然后在真实对话中冻结。不是因为您没有学习单词，而是因为您的大脑说，<em>这看起来不像我们保存那些的地方。</em></p>
      
      <h2>当一致性适得其反时</h2>
      <p>我们喜欢听到一致性是关键。当涉及到出现时，确实如此。</p>
      
      <p>但位置的一致性实际上可能使您的记忆脆弱。</p>
      
      <p>如果您只在完美条件下学习，您的大脑会学习一个危险的规则：</p>
      
      <p><em>这种语言只存在于这里。</em></p>
      
      <p>这很好，直到您累了。或者压力大。或者站在嘈杂的机场试图解释一些重要的事情。</p>
      
      <p>强大的记忆不是整洁的。它们是灵活的。</p>
      
      <h2>修复：停止像雕像一样学习</h2>
      <p>这是令人惊讶的简单解决方案：移动。</p>
      
      <p>不要一次全部。不要戏剧性地。只要足够让您的大脑不会将记忆锁定在一个地方。</p>
      
      <p>试试这个：</p>
      
      <ul>
        <li>在有风和干扰的公园长椅上复习词汇</li>
        <li>在有背景噪音的咖啡馆做短时间练习</li>
        <li>边走边大声说话</li>
        <li>坐在地板上而不是椅子上</li>
      </ul>
      
      <p>甚至您的内部状态也很重要：</p>
      
      <ul>
        <li>在放松时学习一次</li>
        <li>在稍微疲倦时学习一次</li>
        <li>在运动后学习一次</li>
      </ul>
      
      <p>您发送给大脑的信息是微妙但强大的：</p>
      
      <p><em>这些单词在任何地方都很重要。</em></p>
      
      <p>随着时间的推移，您的记忆停止依赖环境线索并变得可携带。</p>
      
      <h2>为什么门口让您忘记（以及如何使用它）</h2>
      <p>门口抹去想法是有原因的。</p>
      
      <p>您的大脑将物理转换视为心理重置。新房间，新上下文，新"文件"。</p>
      
      <p>您实际上可以使用这个。</p>
      
      <ul>
        <li>在一个房间开始一个句子。</li>
        <li>在另一个房间完成它。</li>
        <li>在走过房子时复习一个短语。</li>
      </ul>
      
      <p>每个小的变化都迫使您的大脑在变化中保持语言 — 就像在注意力上添加脚踝重量。</p>
      
      <h2>当您卡住时的心理捷径</h2>
      <p>有时您无法选择您的环境。</p>
      
      <p>您紧张。您空白。单词消失了。</p>
      
      <p>有一个技巧：心理恢复。</p>
      
      <p>半秒钟，想象您通常学习的地方。</p>
      <p>桌子。灯光。气味。感觉。</p>
      
      <p>因为您的记忆与那个地方相关，在心理上回到那里可以解锁您正在寻找的单词。</p>
      
      <p>这听起来很奇怪。它比您预期的更经常有效。</p>
      
      <h2>让世界成为您的教室</h2>
      <p>目标不是擅长学习语言。</p>
      
      <p>目标是使用它 — 在混乱、嘈杂、不可预测的情况下。</p>
      
      <p>所以停止追求完美的设置。改变房间。改变时间。改变心情。让您的学习变得有点嘈杂。</p>
      
      <p>您不仅仅在记忆词汇。</p>
      
      <p>您正在教您的大脑这种语言属于您去的任何地方。</p>`,
  blogArticle13Title: "为什么您的大脑在一点混乱中实际上学得更好",
  blogArticle13Excerpt: "那些完美组织的语言教科书让人感到安慰。但这里有一个不舒服的真相：您的大脑在事情整洁时学得并不最好。它在事情有点…混乱时学得最好。",
  blogArticle13Author: "SafaCards团队",
  blogArticle13Content: `<p>让我们诚实一秒钟。</p>
      
      <p>那些完美组织的语言教科书—那些整齐地从问候到家庭到在餐厅的—让人感到安慰。一切都贴了标签。一切都是可预测的。感觉像进步。</p>
      
      <p>但这里有一个不舒服的真相：</p>
      
      <p>您的大脑在事情整洁时学得并不最好。</p>
      <p>它在事情有点…混乱时学得最好。</p>
      
      <p>不是随机混乱。不是恐慌。</p>
      <p>而是那种迫使您的大脑保持清醒的生产性困惑。</p>
      
      <p>认知科学家对此有一个名称（听起来比实际更可怕）：期望困难。想法很简单：当学习感觉稍微不舒服时—当您必须稍微挣扎时—您的大脑更有可能在几周或几个月后记住您正在做的事情。</p>
      
      <p>如果语言学习感觉太顺利，有些不对劲。</p>
      
      <h2>让您认为您流利的陷阱（当您不是时）</h2>
      <p>有这么多学习者在家里感觉很好…在真实对话中完全冻结是有原因的。</p>
      
      <p>这是心理学家称之为流利错觉的东西。</p>
      
      <p>您见过它发生。您看一个词汇表。您看到窗户的单词。您的大脑说，<em>哦是的，我知道那个。</em>您翻转卡片。金星。继续前进。</p>
      
      <p>但识别不是知道。</p>
      
      <p>识别是您的大脑说，<em>这看起来很熟悉。</em></p>
      <p>知道是您的大脑说，<em>我可以从无到有找到这个词，在压力下，当有人在等我说话时。</em></p>
      
      <p>大多数传统学习方法训练识别，因为它感觉有回报。您移动得快。您感觉聪明。您的连续记录保持活跃。</p>
      
      <p>现实生活不在乎。</p>
      
      <p>没有人在街上给您多项选择选项。没有人在您扫描心理单词表时等待。那就是错觉崩溃的时候。</p>
      
      <h2>为什么混合一切有效（即使它很烦人）</h2>
      <p>将"良好混乱"引入学习的最强大方法之一是一种叫做交错的东西。</p>
      
      <p>通常，学习看起来像这样：</p>
      
      <ul>
        <li>20个过去时态的句子</li>
        <li>相同的结构</li>
        <li>相同的主题</li>
        <li>到第五句时大脑处于自动驾驶状态</li>
      </ul>
      
      <p>感觉高效。但您的大脑很快意识到它不再需要思考—它只是遵循模式。</p>
      
      <p>交错做相反的事情。</p>
      
      <p>您在主题、时态和情况之间跳跃：</p>
      
      <ul>
        <li>一个过去时的句子</li>
        <li>一个关于食物的</li>
        <li>一个关于计划的</li>
        <li>一个随机的意见</li>
      </ul>
      
      <p>感觉更难。更慢。更令人沮丧。</p>
      
      <p>这正是它有效的原因。</p>
      
      <p>您的大脑不能滑行。它必须不断重置。这种努力创造了更强、更灵活的记忆路径。</p>
      
      <p>这就像在跑步机上行走和在崎岖地面上徒步旅行之间的区别。跑步机更容易。小径实际上改变了您。</p>
      
      <h2>为什么错误是学习的最快方式</h2>
      <p>我们大多数人被训练害怕错误。</p>
      
      <p>红墨水意味着失败。错误答案意味着尴尬。所以我们直接将这种本能带入语言学习—它悄悄地破坏我们。</p>
      
      <p>这是转折：当您得到正确的东西时，您的大脑几乎没有反应。</p>
      <p>当您得到几乎正确的东西并错过它时？您的大脑亮起来。</p>
      
      <p>那个时刻—"呃，我几乎得到了"—创造了注意力和可塑性的激增。科学家称之为预测错误，但您知道它是那种尖锐的小烦恼感。</p>
      
      <p>那种感觉是金子。</p>
      
      <p>您挣扎一次的单词通常比您连续十次正确的单词更好地坚持。错误创造心理"钩子"。当正确答案最终落地时，它有地方附着。</p>
      
      <p>所以是的—听起来错误是进步。</p>
      
      <h2>与"我几乎知道这个"坐在一起的魔力</h2>
      <p>您知道当单词就在那里，只是够不到时的感觉吗？</p>
      
      <p>您的本能是立即抓住手机并查找它。</p>
      
      <p>抵抗那种冲动。只是一瞬间。</p>
      
      <p>那种不舒服的搜索感觉被称为搜索努力，这是我们拥有的最强记忆构建者之一。即使您失败并最终查找单词，挣扎也会让您的大脑准备好抓住它。</p>
      
      <p>立即查找某些东西就像吃预先咀嚼的食物。</p>
      <p>您获得卡路里—但没有力量。</p>
      
      <h2>为什么完美主义悄悄阻碍您</h2>
      <p>最好的语言学习者不是最聪明或最有纪律的。</p>
      
      <p>他们是最混乱的。</p>
      
      <p>他们愿意在准备好之前说话。</p>
      <p>他们使用错误的时态只是为了把想法说出来。</p>
      <p>他们听起来很荒谬—但仍然继续。</p>
      
      <p>完美主义让您被困在您已经知道的东西里。混乱将您推入您不知道的东西。</p>
      
      <p>那就是语言真正存在的地方。</p>
      
      <p>一旦您放弃听起来"正确"，其他事情就会发生：您开始听到节奏。模式。流动。您停止逐字翻译，开始感受语言如何移动。</p>
      
      <p>那不是您可以组织方式进入的东西。</p>
      
      <h2>信任混乱阶段</h2>
      <p>语言学习不是直线上升。</p>
      
      <p>它是平的…平的…平的…然后突然—砰—您理解了一个您甚至没有试图理解的句子。</p>
      
      <p>那些跳跃不是来自整洁的学习会话。</p>
      <p>它们来自您的大脑悄悄整理数周的困惑。</p>
      
      <p>所以当学习会话感觉分散、令人沮丧或不生产时，不要恐慌。</p>
      
      <p>那不是失败。</p>
      <p>那是建筑噪音。</p>
      
      <p>您的大脑正在重新安排事情。</p>
      
      <p>很快有一天，没有警告，它会点击。</p>`,
  blogArticle14Title: "为什么您在另一种语言中听起来不像'您'（以及为什么这根本不是坏事）",
  blogArticle14Excerpt: "您是否曾经在另一种语言中说话时中途发现自己，并想，现在说话的是谁？您不是在想象—当您说另一种语言时，您的个性确实会改变。这根本不是坏事。",
  blogArticle14Author: "SafaCards团队",
  blogArticle14Content: `<p>您是否曾经在另一种语言中说话时中途发现自己，并想，<em>现在说话的是谁？</em></p>
      
      <p>也许您的声音提高了一个音调。</p>
      <p>也许您的手突然无法保持静止。</p>
      <p>也许您感觉更大胆、更安静、更有趣，或者奇怪地比平时更有礼貌。</p>
      
      <p>这可能感觉…令人不安。就像您稍微走出了自己。</p>
      
      <p>但问题是：您不是在想象—您绝对没有失去理智。您正在经历的是学习新语言最迷人（也是最少被谈论）的部分之一。</p>
      
      <h2>是的，您的个性确实会改变</h2>
      <p>多年来，人们把这当作一个可爱的轶事而忽略。"哦，我只是在西班牙语中不同。"可爱，但不严肃。</p>
      
      <p>然后心理学家实际上测试了它。</p>
      
      <p>他们给双语者进行个性评估—一次用一种语言，然后用另一种语言再次进行。同样的问题。同样的人。完全不同的结果。</p>
      
      <p>某人会在一种语言中显得更外向。在另一种语言中更谨慎或更注重细节。</p>
      
      <p>同样的人。不同的语言。不同的版本。</p>
      
      <p>为什么？</p>
      
      <p>因为当您学习一种语言时，您不只是记忆语法规则。您吸收语调。时机。社会期望。您学习什么被认为是自信、礼貌、有趣或粗鲁—通常没有意识到。</p>
      
      <p>您的大脑悄悄地将语言与您学习它的地点和方式联系起来。</p>
      
      <p>如果您通过写压力大的工作邮件学习英语，那种语言带有压力。</p>
      <p>如果您通过与朋友笑或点餐学习西班牙语，那种语言感觉更温暖。</p>
      <p>如果您在咖啡馆学习法语，它可能会更流畅、更放松—即使您内心紧张。</p>
      
      <p>您不是在切换个性。您是在切换上下文。</p>
      
      <h2>为什么第二语言在情感上感觉更安全</h2>
      <p>这种分裂自我的感觉还有另一个奇怪的好处，它被称为外语效应。</p>
      
      <p>您的母语是有负担的。每个词都与童年、争论、赞美、尴尬、舒适纠缠在一起—所有的一切。</p>
      
      <p>第二语言不承担那种重量。</p>
      
      <p>所以当有人用您的非母语说一些严厉的话时，它落地更柔和。它感觉更像信息而不是对胸部的打击。</p>
      
      <p>奇怪的是，这种情感距离可以让您更清楚地思考。</p>
      
      <p>研究表明，当人们用第二语言思考时，他们会做出更理性的决定—财务、道德，甚至医疗。情绪仍然存在，但它们不会劫持方向盘。</p>
      
      <p>这就像为您的感受有一个内置的暂停按钮。</p>
      
      <h2>您的嘴确实在做不同的事情</h2>
      <p>这不仅仅是心理上的。这是身体上的。</p>
      
      <p>语言生活在身体的不同地方。</p>
      
      <p>英语停留在喉咙后面。</p>
      <p>法语坐在嘴唇前面。</p>
      <p>意大利语将您拉入宽元音和开放表情。</p>
      
      <p>要很好地讲一种新语言，您必须重塑您的嘴、下巴和呼吸。您正在使用在母语中几乎注意不到的肌肉。</p>
      
      <p>这是疯狂的部分：姿势和表情反馈到情绪中。</p>
      
      <p>像意大利语说话者那样保持您的嘴足够长的时间，很难不感到更有活力一点。</p>
      <p>倾向于法语发音，突然一切都慢下来了。</p>
      
      <p>您不是在假装。您的身体正在参与。</p>
      
      <h2>那个尴尬的"我是谁？"阶段实际上是一个礼物</h2>
      <p>许多学习者会遇到一个奇怪的时刻，他们感到虚假。</p>
      
      <p>"我的第二语言自我不是真正的我。"</p>
      <p>"我听起来像在表演。"</p>
      <p>"我不认识自己。"</p>
      
      <p>但如果这不是问题呢？</p>
      
      <p>如果学习另一种语言不取代您是谁—它扩展了您可以成为的范围呢？</p>
      
      <p>大多数人只得到一个声音，一个音调，一种显示自信或脆弱的方式。语言学习打破了这一点。它向您展示身份不是单一、坚固的东西。它是灵活的。情境的。令人惊讶地适应性强。</p>
      
      <p>那不是身份危机。</p>
      <p>那是范围。</p>
      
      <h2>所以不要与"外语您"作斗争</h2>
      <p>如果您的手移动得更多，让它们移动。</p>
      <p>如果您的声音改变，让它改变。</p>
      <p>如果您感觉更勇敢、更平静、更敏锐或更柔和—注意它。</p>
      
      <p>这些变化不是您虚假的迹象。它们是您的大脑正在做一些非常复杂的事情的迹象：将声音、文化、记忆和运动同步到一个系统中。</p>
      
      <p>学习语言是唯一让您暂时走出通常习惯并从新角度看待自己的爱好。</p>
      
      <p>所以去吧。试试存在于另一种语言中的您版本。</p>
      
      <p>您没有失去自己。</p>
      <p>您正在发现有多少版本一直在那里。</p>`,
  blogArticle15Title: "思想的架构：您的语言会改变您的现实吗？",
  blogArticle15Excerpt: "您是否曾经尝试用另一种语言说一些非常熟悉的东西—然后突然感到愚蠢？那个时刻正在向您展示语言不仅仅是包装思想的方式。它是这些思想首先形成方式的一部分。",
  blogArticle15Author: "SafaCards团队",
  blogArticle15Content: `<p>您是否曾经尝试用另一种语言说一些非常熟悉的东西—然后突然感到愚蠢？不是因为您不知道语法，而是因为感觉本身拒绝正确表达。您知道您的意思。您几乎可以触摸到它。但您拥有的词就是不合适。所以您停下来，耸耸肩，或者满足于足够接近的东西。</p>
      
      <p>那个时刻正在做重要的事情。它正在向您展示语言不仅仅是事后包装思想的方式。它是这些思想首先形成方式的一部分。您成长时使用的语言悄悄地训练您的注意力。它推动您的记忆。它告诉您的大脑什么值得注意，什么可以安全地淡入背景。</p>
      
      <p>一旦您意识到这一点，很难不想知道您的"现实"有多少与您可用的词联系在一起。</p>
      
      <h2>当海洋不是蓝色时</h2>
      <p>古代文学中有一个细节，起初听起来几乎不可能。在《奥德赛》中，荷马将大海描述为"酒色深暗。"不是蓝色。不是闪烁的。只是黑暗和沉重。很长一段时间，人们认为这是诗歌许可。</p>
      
      <p>但后来学者注意到更奇怪的事情：荷马从未使用过表示蓝色的词。</p>
      
      <p>事实证明，许多古代文化都没有。蓝色不是一个单独的类别。它与绿色或深色色调归为一组。对我们来说，这听起来很荒谬—蓝色感觉很明显。但感觉明显的东西往往只是我们被训练看到的东西。</p>
      
      <p>现代实验支持这一点。没有明确表示蓝色词的语言的说话者在并排显示时，区分蓝色和绿色的速度较慢。他们的眼睛没问题。区别是心理上的。如果您的语言从未告诉您这种区别很重要，您的大脑不会急于做出这种区别。</p>
      
      <p>当您学习新语言时，这也会开始发生在您身上—悄悄地。您注意到以前从未命名过的情感区别。您过去经常忽略的社交线索。突然感觉重要的意义中的微妙差异。世界没有改变。您改变了。</p>
      
      <h2>时间对每个人来说移动方式不同</h2>
      <p>我们倾向于认为时间是显而易见的。过去在我们身后。未来在前面。我们向前移动。这就是它的工作方式…对吗？</p>
      
      <p>不完全是。</p>
      
      <p>一些语言将时间描述为垂直的。其他语言将其与地理联系起来。在一些文化中，时间从东向西流动，跟随太阳。而在其他文化中，人们谈论空间的方式迫使他们不断在物理世界中保持方向感。</p>
      
      <p>最引人注目的例子之一来自一个名为Kuuk Thaayorre的澳大利亚原住民社区。他们的语言不使用"左"或"右。"永远。一切都使用北、南、东和西来描述。如果您要求某人移动杯子，他们可能会说，"把它稍微向东北移动。"</p>
      
      <p>由于这个原因，Kuuk Thaayorre说话者发展出惊人的方向感。他们几乎总是知道北在哪里，即使在室内或不熟悉的地方。这不是遗传天赋。这是由语言塑造的注意力。</p>
      
      <p>学习这样的语言不仅会给您新的词汇。它会悄悄地改变您体验空间本身的方式。</p>
      
      <h2>语言如何塑造责备和记忆</h2>
      <p>语言甚至影响我们谈论事故的方式—以及我们之后记住的内容。</p>
      
      <p>想象一个花瓶从桌子上掉下来并破碎。在英语中，我们可能会说，"他打破了花瓶，"即使这显然是意外的。我们的语法推动我们分配责任。</p>
      
      <p>在西班牙语中，人们经常说"Se rompió el florero，"这更接近翻译为"花瓶自己破了。"</p>
      
      <p>这种差异很重要。在人们观看意外事件视频的研究中，英语说话者更擅长记住谁造成了事故。西班牙语说话者更擅长记住这完全是一个事故。</p>
      
      <p>语言就像一个聚光灯。它不会平等地照亮一切。它突出某些细节，让其他细节保持暗淡。随着时间的推移，这不仅塑造了我们谈论事件的方式—还塑造了我们如何记住它们和判断它们。</p>
      
      <h2>为什么用另一种语言思考会感觉奇怪地平静</h2>
      <p>说多种语言的人经常注意到一些微妙但令人惊讶的事情。用第二语言思考可能感觉…更安静。情感上不那么紧张。</p>
      
      <p>研究人员称之为外语效应。您的第二语言通常与童年、家庭冲突或根深蒂固的情感习惯无关。它给您一点距离。这种距离可以让决定感觉更清晰，反应更少。</p>
      
      <p>不是您的第二语言更逻辑。而是它不承担相同的情感重量。有时，这正是您需要的。</p>
      
      <h2>学习另一种语言的真正礼物</h2>
      <p>语言学习经常被作为实用技能出售。对工作或旅行有用的东西。当然—它可以是。</p>
      
      <p>但更深的礼物是完全不同的东西。</p>
      
      <p>每种新语言都给您另一种组织经验的方式。另一种谈论时间、情感、责任和联系的方式。您开始意识到您的母语不仅教您如何说话—它悄悄地教您如何看。</p>
      
      <p>学习另一种语言放松了那个框架。它提醒您，您体验世界的方式不是唯一的方式。还有其他镜头。其他默认值。其他成为人类的方式。</p>
      
      <p>逐字逐句，您不仅仅在添加词汇。</p>
      <p>您正在扩展您的思想被允许移动的空间。</p>`,
  blogArticle16Title: "机器中的幽灵：为什么您的大脑还不能'听到'新语言",
  blogArticle16Excerpt: "您是否曾经尝试听外语并想，这甚至不是单词—这只是声音？您没有问题。您的大脑学会了忽略您母语中不存在的音。以下是如何重新训练它。",
  blogArticle16Author: "SafaCards团队",
  blogArticle16Content: `<p>您是否曾经尝试听外语并想，<em>这甚至不是单词—这只是声音？</em>不是句子。不是停顿。只是一个快速、滑溜的模糊，您的大脑无法抓住。这可能感觉几乎荒谬，就像其他人都得到了剧本，而您正在通过墙壁听。</p>
      
      <p>如果那是您的经历，深呼吸。您没有问题。您不擅长语言，您绝对没有"缺少基因。"正在发生的事情实际上非常人性化—一旦您理解了它，整个事情就变得不那么令人沮丧了。</p>
      
      <h2>您的大脑学会了故意忽略事物</h2>
      <p>当您还是婴儿时，您的大脑有点令人惊叹。您可以听到一切。世界各地语言中使用的每一个微小的声音差异。在那个时候，您的大脑不知道什么以后会重要，所以它保持所有选项开放。</p>
      
      <p>但这不会持续。</p>
      
      <p>随着您成长，您的大脑必须变得高效。它开始注意到哪些声音在您的日常生活中有用，并悄悄地决定，<em>好的，这些很重要。</em>其他一切都淡入背景。不是消失—只是模糊了。</p>
      
      <p>到成年时，那个过滤器非常强。所以当您听到母语中不存在的音时，您的大脑不会将它们视为有意义的。它把它们当作噪音。这就是为什么新语言听起来像一个没有空格的长词。您不是听不到—您被训练不去听。</p>
      
      <h2>他们说话不快—您只是还看不到接缝</h2>
      <p>几乎每个语言学习者都说同样的话："母语者说话太快。"这感觉是真的。感觉压倒性。</p>
      
      <p>但大多数时候，速度不是真正的问题。</p>
      
      <p>在您的母语中，您的大脑不会逐字母处理声音。它立即将语音分解成块—单词、短语、意义。您没有注意到它发生，因为它是自动的。</p>
      
      <p>在新语言中，您的大脑还没有学会那些断点在哪里。这就像听音乐而不知道节拍在哪里。所以当您仍在试图弄清楚第一个词时，说话者已经继续了。这很累人—它让您感觉慢，即使您不是。</p>
      
      <h2>为什么"多听"会感觉如此令人沮丧</h2>
      <p>人们喜欢给出建议"多听。"虽然这没有错，但它可能是误导性的。</p>
      
      <p>如果您听一些您完全不懂的东西，您的大脑没有太多可以工作的。这就像盯着静态并希望出现图像。真正有帮助的是听一些您理解部分内容的东西。</p>
      
      <p>那些熟悉的词就像抓手。它们帮助您的大脑猜测词在哪里开始和结束。一旦这开始发生，噪音慢慢变成结构化的东西。还不清楚—但可识别。</p>
      
      <h2>您的大脑即使在您发誓它没有时也在学习</h2>
      <p>这是大多数人没有意识到的部分：即使当您感到迷失时，您的大脑也在注意。</p>
      
      <p>它悄悄地注意到模式。哪些音倾向于一起出现。哪些重复。随着时间的推移，它开始将它们分组为词，而您没有有意识地学习它们。这就是为什么一个短语可能突然感觉熟悉，即使您从未坐下来记忆它。</p>
      
      <p>这也是为什么一致性比强度更重要。每天十分钟比每周一次两小时做得更多。您正在给大脑提供例子，它在幕后整理它们。</p>
      
      <h2>边听边读确实有帮助</h2>
      <p>如果单独听感觉无法忍受，给自己一些支持。边听边读向您的大脑准确显示词边界在哪里。它将声音连接到具体的东西。</p>
      
      <p>对许多人来说，这是事情终于开始转变的时候。语言仍然不容易—但它不再感觉不可能。模糊变软。形状开始出现。</p>
      
      <h2>对每个人都讨厌的阶段要有耐心</h2>
      <p>这个阶段—"一切都听起来像噪音"阶段—老实说是语言学习最困难的部分。它感觉没有成效。它感觉像您在浪费时间。它干扰您的信心。</p>
      
      <p>但它也是暂时的。</p>
      
      <p>每次您听，即使您只抓住一两个词，您都在慢慢重新训练您的大脑。您告诉它，<em>这些音现在很重要。请注意。</em></p>
      
      <p>然后有一天，通常当您最不期望时，某些东西点击了。您理解一个句子而不翻译。您跟随对话的一部分。噪音突然听起来像语言。</p>
      
      <p>那个时刻感觉不可思议。</p>
      
      <p>它只发生是因为您愿意坐在它没有发生的部分。</p>`,
  blogArticle17Title: "为什么学习一门新语言实际上是给自己的礼物",
  blogArticle17Excerpt: "大多数人谈论学习语言的方式就像谈论多喝水一样。就像……是的，这可能对我有什么好处。但是，如果“有用”是你这样做的唯一原因，那么你就会错过它的独特之处。",
  blogArticle17Author: "SafaCards团队",
  blogArticle17Content: `<p>大多数人谈论学习语言的方式就像谈论多喝水一样。</p>
      
      <p>就像……是的，这可能对我有什么好处。实用。负责任。“我以后应该那样做。”</p>
      
      <p>当然——语言很有用。它们有助于旅行、工作、点餐，而不需要像玩猜谜游戏那样指着菜单上的随机项目。</p>
      
      <p>但是，如果“有用”是你这样做的唯一原因，那么你就会错过它的独特之处。</p>
      
      <p>因为一旦你学习一门语言足够长的时间，过了初学者阶段——过了“嗨，我叫……”每个人都觉得像是学校作业的阶段——它就不再是这个整洁的小型自我提升项目了。</p>
      
      <p>它变得个性化。它变得令人沮丧。它以你没有报名的方式变得奇怪地情绪化。</p>
      
      <p>然后，如果你坚持下去，它就会成为那些罕见的付出比索取更多的事物之一。</p>
      
      <h2>它开始是一项技能……然后它开始扰乱你的身份（以好的方式）</h2>
      <p>起初，你基本上是一个带着焦虑行走的字典。</p>
      
      <p>你听到一个句子，你在脑海中翻译它，你反应缓慢，你怀疑每一个单词，你一直在做那个礼貌的微笑，上面写着，“我在尝试，请不要惊慌。”</p>
      
      <p>但后来发生了一些事情，通常是在你不期望的时候。</p>
      
      <p>你不翻译就理解了一个句子。你在还没有时间过度思考之前就回答了。你说了些什么，它出来了……有点自然。</p>
      
      <p>然后你意识到：哦。这门语言有一种氛围。</p>
      
      <p>或者也许你有——在那门语言中。</p>
      
      <p>很多人注意到他们听起来像是稍微不同版本的自己。不是假的。只是……不同。</p>
      
      <p>也许你更幽默。也许你更安静。也许你更直率。也许你更深情。也许你突然变成了那种用手做戏剧性表情的人。（这发生了。很多。）</p>
      
      <p>就像语言让你接触到了你第一语言自然无法引出的自己的一面。</p>
      
      <p>那不是简历能捕捉到的，但它是真实的。</p>
      
      <h2>它教你如何在不崩溃的情况下感到不舒服</h2>
      <p>语言学习以一种非常特定的方式让人谦卑。</p>
      
      <p>你可以是一个能干的成年人——聪明、善于表达、完全有能力——然后突然你无法说出一个基本的想法，比如“我用完了牙膏”，听起来不像一个困惑的幼儿。</p>
      
      <p>起初这令人气愤。</p>
      
      <p>你忘记了你昨天刚学的单词。你理解句子中的每一个单词……但在某种程度上不理解句子。你听到同一个短语十次，只有在第十次你的大脑才会说，“哦哦。这就是那个意思。”</p>
      
      <p>但这是偷偷摸摸的礼物：你开始更擅长感到困惑。</p>
      
      <p>你学会如何猜测。如何恢复。如何在缺少片段时继续说话。你不再需要在开口前一切完美。</p>
      
      <p>这项技能以最意想不到的方式溢出到你的生活中。</p>
      
      <p>你对自己更有耐心。你更好地处理尴尬时刻。当你没有立即知道答案时，你不再惊慌失措。</p>
      
      <p>不是你变得“更聪明”。而是你变得更灵活。更有韧性。</p>
      
      <p>这很罕见且有价值，老实说……相当自由。</p>
      
      <h2>它让你对他人更友善（几乎是偶然的）</h2>
      <p>一旦你成为了那个努力说话的人，你就无法视而不见。</p>
      
      <p>你停止评判口音。你停止打断别人。你注意到用不是你的语言说一件简单的事情需要多少努力。</p>
      
      <p>因为你在骨子里感觉到了：你想清楚地表达某事的那一刻，你只是……不能。还不能。不是用你拥有的单词。</p>
      
      <p>所以你开始注意到努力而不是错误。</p>
      
      <p>那种同理心不是表演性的。这不是“做一个好人”的提示。</p>
      
      <p>这只是当你经历过它时会发生的事情。</p>
      
      <h2>进步出现在感觉巨大的微小瞬间</h2>
      <p>没有哪一刻你醒来就流利了。没有神奇的“升级”屏幕。</p>
      
      <p>它更像是……生活继续发生，你的语言能力悄悄地开始出现在其中。</p>
      
      <p>你理解了一首歌中的歌词，你多看了一眼。你在节目中捕捉到一个短语，你甚至没有伸手去拿字幕。你开玩笑，有人在正确的时间笑，你意识到你没有翻译任何东西。</p>
      
      <p>那些时刻在外表上很小，但在内部它们像烟花一样。</p>
      
      <p>因为你知道它们背后有多少工作。所有尴尬的对话，所有的重复，所有的“等等，他们刚才说什么？”时刻。</p>
      
      <p>没有人为此给你颁发证书。但你感觉到了。</p>
      
      <h2>它打开你的世界……悄悄地</h2>
      <p>一门新语言不会伴随着某种戏剧性的宣布。它只是给你访问权。</p>
      
      <p>突然间，你曾经忽略的音乐变得有意义。去年你看不懂的标题变得可读。曾经感觉封闭的对话现在感觉像是你可以介入的事情。</p>
      
      <p>最大的转变是微妙的：</p>
      
      <p>你不再感觉自己站在外面往里看。</p>
      
      <p>你开始感觉自己属于这个房间。</p>
      
      <p>这是件大事。比“有用”更大。</p>
      
      <h2>不——你没有错过机会</h2>
      <p>人们喜欢说，“如果你小时候没学，那就太晚了。”</p>
      
      <p>但成年人带来了孩子没有的东西。</p>
      
      <p>你有理由。你有品味。你有背景。你可以将语言与真实经历和真实的人联系起来。你可以选择你在乎什么。你可以注意到细微差别。你可以建立一个真正适合你生活的练习。</p>
      
      <p>你不需要完美。你不需要听起来像母语者。你不需要第一天就有信心。</p>
      
      <p>你不需要完美。你不需要听起来像母语者。你不需要第一天就有信心。</p>
      
      <p>你只需要愿意在一段时间内有点笨拙。</p>
      
      <p>如果你能做到这一点，回报不仅仅是“能够说另一种语言”。</p>
      
      <p>回报是你在学习过程中成为谁。</p>
      
      <p>更耐心。更在场。更极好奇。更连接。</p>
      
      <p>在某一点上你会意识到一些有趣的事情：</p>
      
      <p>它从来真的不仅仅是关于语言。</p>`,
  blogArticle18Title: "为什么你的大脑比你想象的更擅长语言",
  blogArticle18Excerpt: "（“附带”学习的安静力量）。如果你曾经做过整个“我要对这件事认真起来”的事情——然后在大约……20 分钟后感到真的很疲惫？你并不孤单。",
  blogArticle18Author: "SafaCards团队",
  blogArticle18Content: `<p>如果你曾经做过整个“我要对这件事认真起来”的事情——坐下来拿着教科书，削尖你不需要的铅笔，努力读完几页语法——然后在大约……20 分钟后感到真的很疲惫？</p>
      
      <p>你并不孤单。那种被掏空、稍微有点恼火的“为什么这感觉像是在推车上山”的感觉并不是你语言能力差的证明。</p>
      
      <p>这是你的大脑在给你提示：这不是它最喜欢的学习方式。</p>
      
      <p>我们都被教导说“真正的学习”必须看起来像某种特定的样子。坐在桌子旁。非常努力地集中注意力。记忆。受一点苦。否则它“不算数”。</p>
      
      <p>但语言不是那样建立的。</p>
      
      <p>语言是混乱的。它是社会性的。它是重复的。它是人类最初通过整天在它周围而学到的东西，而不是通过填空和圈出正确的变位。</p>
      
      <p>一旦你开始依赖这个事实，语言学习就会变得不那么令人疲惫，而且更加……可行。</p>
      
      <h2>你的大脑已经知道如何学习一门语言（你以前做过）</h2>
      <p>想想你是如何学习你的第一语言的。</p>
      
      <p>没有人三岁时给你一张语法图表说，“好吧，这是虚拟语气。让我们开始吧。”</p>
      
      <p>你学会了是因为你被它包围。</p>
      
      <p>你在吃饭、玩耍、被吼、看卡通片、发呆、问了400次“为什么”、通常过着你的小生活时听到它。你的大脑在你不自觉尝试的情况下通过模式捕捉到了。</p>
      
      <p>它学到了：</p>
      
      <ul>
        <li>什么声音通常在一起</li>
        <li>人们在某些情况下倾向于说什么</li>
        <li>句子正确时“感觉”如何</li>
        <li>语气意味着什么（这老实说是成功的一半）</li>
      </ul>
      
      <p>这种学习被称为隐性学习，但你不需要这个术语。你只需要这个想法：</p>
      
      <p>你的大脑真的非常擅长在后台吸收语言。</p>
      
      <p>这是人们忘记的部分：这种能力当你成年后并没有消失。你仍然拥有它。你只是不再信任它了。</p>
      
      <p>作为成年人，我们试图通过有意识的学习来强行通过一切——大脑喜欢规则和列表的那部分。那部分可以帮忙，但它很快就会累。而且它不擅长混乱的现实生活版语言，那里人们说话太快，吞掉一半的单词，并使用你在教科书中永远找不到的俚语。</p>
      
      <h2>“什么都不做”会让你累……这就是重点</h2>
      <p>你有没有在一个你不说那门语言的地方呆过一天，最后感到奇怪地筋疲力尽？</p>
      
      <p>就像你没有做任何激烈的事情。你只是存在。也许你四处走动，买东西，听你无法理解的对话……然后你回到酒店，感觉你的大脑一直在加班。</p>
      
      <p>那是因为它确实在加班。</p>
      
      <p>即使当你认为你没有在注意时，你的大脑也在倾听。它捕捉节奏。重复的声音。小模式。它试图理解它听到的内容，而你只是试图找到洗手间或阅读标志而不惊慌。</p>
      
      <p>这就是为什么“懒惰接触”实际上很重要：</p>
      
      <ul>
        <li>做饭时播放播客</li>
        <li>打扫时听音乐</li>
        <li>浏览时后台播放节目</li>
        <li>你半看的目标语言短视频</li>
      </ul>
      
      <p>你不是坐在那里做闪卡，所以这感觉不像是生产力。但你的大脑一直在收集数据。</p>
      
      <p>这就像你的大脑在外面撒了一张小网。你看不到它在抓东西，但它在抓。</p>
      
      <h2>为什么进步感觉不可见（直到突然可见）</h2>
      <p>这是让人困惑的部分。</p>
      
      <p>当你以“传统”方式学习时，你可以衡量它。你学会了20个单词。你完成了一章。你做了练习。你可以打勾并感到有成就感。</p>
      
      <p>但在附带学习中，它更安静。你可能看20分钟的节目，基本上什么都不懂，然后想，酷，我刚刚浪费了我的生命。</p>
      
      <p>除了你没有。</p>
      
      <p>正在发生的事情更像是滴水穿石填充罐子。有一段时间看起来没有任何变化。然后有一天，不知从哪里冒出来，你通过直觉立即认出了一个单词。</p>
      
      <p>这是一个如此奇怪的时刻，因为你不记得学过它。</p>
      
      <p>你没有坐下来“记忆”它。它只是……出现在你的脑海中，就好像它一直都在那里一样。</p>
      
      <p>那是你的大脑从它一直做的后台工作中提取出来的东西。</p>
      
      <p>那些时刻感觉像魔法。它们不是魔法。它们是回报。</p>
      
      <h2>最大的“黑客”不是更努力。而是更在乎。</h2>
      <p>如果有一件事真的能让附带学习起作用，那不是纪律。不是强迫自己看你讨厌的无聊教育视频。</p>
      
      <p>是兴趣。</p>
      
      <p>就像真正的兴趣。</p>
      
      <p>如果你参与其中，你的大脑就会保持开放。它停止纠结于“我理解这个吗？”并开始关注意义。你放松了。你变得好奇。压力下降了——而压力是一个巨大的语言杀手。</p>
      
      <p>所以不要挑选“好”内容。挑选你真正想要的内容：</p>
      
      <ul>
        <li>讨厌新闻？别读它。</li>
        <li>爱烹饪？看烹饪视频。</li>
        <li>喜欢游戏？更改语言设置并玩。</li>
        <li>痴迷于真人秀？恭喜，你有无限的听力练习。</li>
        <li>喜欢运动？看评论、精彩集锦、采访。</li>
      </ul>
      
      <p>最好的内容是你不用贿赂自己就能回来的内容。</p>
      
      <h2>停止把自己当学生对待</h2>
      <p>这可能是最大的转变。</p>
      
      <p>与其想“我在学习一门语言”，不如试着想“我让这门语言住在我附近” 。</p>
      
      <p>你不需要准备好。你不需要理解一切。你不需要等到你“足够好”才开始消费真实的东西。</p>
      
      <p>让它变得混乱。有时候让它成为背景噪音。允许自己今天只捕捉到5%。</p>
      
      <p>因为目标不是立即理解一切。目标是让语言感觉足够熟悉，以至于你的大脑不再把它当作紧急情况处理。</p>
      
      <p>一旦感觉熟悉，学习就会变得更容易。</p>
      
      <h2>真正的收获</h2>
      <p>教科书和专注学习会有所帮助。它们有它们的位置。它们提供结构。它们回答问题。</p>
      
      <p>但流利不仅仅来自苦读。</p>
      
      <p>它来自接触——大量的接触——以你不重播的歌曲、你半关注的节目、你一遍又一遍听到的短语这种不迷人的形式，直到有一天你意识到你知道它们。</p>
      
      <p>所以是的，在有意义的时候学习。</p>
      
      <p>但也：有时候合上书。放点东西。让语言在你做其他事情的时候飘过你的一天。</p>
      
      <p>你的大脑已经是为此而建的。</p>
      
      <p>你只需要让它以它自然想要的方式学习。</p>`,
  coreFeatures: "核心功能",
  smartVocabularyLists: "智能词汇列表",
  smartVocabularyDescription: "告诉我您想学习什么 - 比如\"烹饪术语\"或\"旅行短语\" - 我会给您在现实生活中真正会使用的单词。",
  learnInContext: "在上下文中学习",
  learnInContextDescription: "与其记忆孤立的单词，您将在真实句子中看到它们。这就像从对话中学习，而不是从字典中学习。",
  practiceWithAI: "阅读故事",
  practiceWithAIDescription: "生成并阅读包含你词汇的自定义故事。在真实语境中看到你的单词，并测试你的理解。",
  allRightsReserved: "版权所有。",

  // About Page
  aboutSafaCards: "关于SafaCards",
  revolutionizingLanguageLearning: "通过AI革新语言学习",
  whyIBuiltSafaCards: "为什么我构建SafaCards",
  whyIBuiltDescription: "我开始学习西班牙语是为了更好地与我的女朋友交流，她是西班牙语母语者。我对传统应用程序感到沮丧，它们让我记忆像\"大象\"这样的随机单词，而我只想与她进行真实对话。所以我构建了SafaCards来解决这个问题 - 您学习在现实生活中真正会使用的单词。",
  howSafaCardsGotName: "SafaCards如何得名",
  howSafaCardsGotNameDescription: "这个名字反映了我们专注于为语言学习提供简单有效的工具。我们想要一个能够突出我们核心关注点——智能数字闪卡的名字。",
  howSafaCardsGotNameDescription2: "我想要一些让人感觉亲切有趣的东西，这与我们让每个人都能轻松学习语言的使命一致。",
  howItWorks: "工作原理",
  pickWhatYouWantToLearn: "1. 选择您想学习的内容",
  pickWhatYouWantDescription: "告诉我您感兴趣的内容 - 也许是\"餐厅词汇\"或\"工作场所术语\"。我会创建一个您在这些情况下真正会使用的单词列表。",
  smartReviewSystem: "2. 智能复习系统",
  smartReviewDescription: "我使用一种叫做间隔重复的技术，在完美的时间向您展示单词 - 就在您即将忘记它们之前。这就像有一个学习伙伴，知道您何时需要复习。",
  learnWordsInContext: "3. 在上下文中学习单词",
  learnWordsInContextDescription: "与其记忆\"苹果 = manzana\"，您将在句子中看到它，比如\"I eat an apple every morning\"。您学习单词在真实对话中是如何实际使用的。",
  practiceWithConversations: "4. 阅读故事",
  practiceWithConversationsDescription: "生成并阅读包含你词汇的自定义故事。在真实语境中看到你的单词，并通过摘要和反馈测试你的理解。",
  behindTheScenes: "幕后",
  behindTheScenesDescription: "我使用现代网络技术和AI工具构建了SafaCards：",
  reactNodejs: "React & Node.js：提供流畅、快速的用户体验",
  googleAI: "Google的AI：生成词汇和练习句子",
  spacedRepetition: "间隔重复：一种经过验证的方法，帮助您更好地记住所学内容",
  realTimeUpdates: "实时更新：确保您的进度始终保存和同步",
  whatMakesSafaCardsDifferent: "是什么让SafaCards与众不同？",
  learnWhatYouNeed: "学习您需要的内容",
  learnWhatYouNeedDescription: "不再记忆随机单词。您学习与生活和目标相关的词汇。",
  scienceBasedLearning: "基于科学的学习",
  scienceBasedLearningDescription: "我使用经过验证的技术，如间隔重复，真正帮助您记住所学内容。",
  realConversations: "真实对话",
  realConversationsDescription: "练习您真正会有的句子和对话，而不是教科书示例。",
  alwaysImproving: "不断改进",
  alwaysImprovingDescription: "我不断根据用户反馈添加新功能并改进应用程序。",
  readyToStartLearning: "准备开始学习？",
  readyToStartDescription: "无论您刚刚开始还是试图提高技能，SafaCards都可以帮助您。它设计得足够简单适合初学者，但对更高级的学习者也有用。试试看，看看语言学习可以变得多么容易。",
  startLearningToday: "今天开始学习",
  backToHome: "返回首页",
  backToBlog: "返回博客",
  readMore: "阅读更多",

  // Privacy Policy Page
  lastUpdated: "最后更新：",
  guideSpacedRepetition: "间隔重复（SM‑2）指南",
  whatIsSm2: "什么是 SM‑2？",
  sm2Intro: "SM‑2 是一种经过验证的间隔重复算法，会在你可能遗忘之前安排复习。每次复习都会根据表现调整间隔。",
  sm2PointAdaptive: "根据对错自适应调整间隔",
  sm2PointDue: "优先复习到期项目以最大化记忆保持",
  sm2PointEfficient: "以更少的学习时间获得同等效果",
  howSafaCardsUsesSm2: "SafaCards 如何使用 SM‑2",
  sm2HowSafaCards: "在 SafaCards 中，“复习所有单词”页面使用 SM‑2。学习模式用于快速接触；熟悉后切换到“复习所有单词”以巩固长期记忆。",
  bestPractices: "最佳实践",
  sm2TipGroups: "每组建议约 25 个单词，便于专注练习。",
  sm2TipLearningMode: "先用学习模式进行热身并多看几次。",
  sm2TipReviewAll: "然后使用“复习所有单词”（SM‑2）来巩固。",
  sm2TipDaily: "尽量每天学习；短而持续的学习优于临时抱佛脚。",
  sm2TipContext: "使用句子和故事来强化理解。",
  faq: "常见问题",
  sm2FaqEditTitle: "编辑单词会丢失进度吗？",
  sm2FaqEditAns: "会。在 SafaCards 中，编辑卡片会重置其 SRS 历史和复习计划。",
  sm2FaqHonestTitle: "猜对了是否应该标记为正确？",
  sm2FaqHonestAns: "请如实标记。过度标记“知道”会导致下次复习间隔过长。",
  sm2FaqBatchTitle: "应该多久添加一次新单词？",
  sm2FaqBatchAns: "建议定期少量新增，以便 SM‑2 合理分配学习负担。",
  informationWeCollect: "我们收集的信息",
  informationWeCollectDescription: "SafaCards收集您直接提供给我们的信息，例如当您创建账户、使用我们的语言学习功能或联系我们寻求支持时。",
  accountInformation: "账户信息",
  accountInformationDescription: "当您创建账户时，我们收集您的电子邮件地址和您选择提供的任何其他信息。",
  usageInformation: "使用信息",
  usageInformationDescription: "我们收集有关您如何使用我们服务的信息，包括您的学习进度、词汇列表以及与我们的AI功能的互动。",
  technicalInformation: "技术信息",
  technicalInformationDescription: "我们自动收集某些技术信息，包括您的IP地址、浏览器类型、设备信息和使用模式。",
  howWeUseYourInformation: "我们如何使用您的信息",
  howWeUseDescription: "我们使用收集的信息来：",
  provideAndImprove: "提供和改进我们的语言学习服务",
  personalizeExperience: "个性化您的学习体验",
  generateAIContent: "生成AI驱动的内容和推荐",
  communicateWithYou: "就您的账户和我们的服务与您沟通",
  ensureSecurity: "确保我们平台的安全性和完整性",
  informationSharing: "信息共享",
  informationSharingDescription: "我们不会向第三方出售、交易或以其他方式转让您的个人信息，除非如本政策所述或经您同意。",
  serviceProviders: "服务提供商",
  serviceProvidersDescription: "我们可能与帮助我们运营平台的受信任第三方服务提供商共享信息，如托管提供商和分析服务。",
  legalRequirements: "法律要求",
  legalRequirementsDescription: "如果法律要求或为了保护我们的权利和安全，我们可能会披露信息。",
  dataSecurity: "数据安全",
  dataSecurityDescription: "我们实施适当的安全措施来保护您的个人信息免受未经授权的访问、更改、披露或破坏。",
  yourRights: "您的权利",
  yourRightsDescription: "您有权：",
  accessAndUpdate: "访问和更新您的个人信息",
  deleteAccountData: "删除您的账户和相关数据",
  optOutCommunications: "选择退出某些通信",
  requestInformation: "请求有关我们如何处理您数据的信息",
  contactUs: "联系我们",
  contactUsDescription: "如果您对本隐私政策有任何问题，请通过应用程序联系我们或发送消息给我们。",

  // Terms of Service Page
  acceptanceOfTerms: "接受条款",
  acceptanceOfTermsDescription: "通过访问和使用SafaCards，您接受并同意受本协议的条款和规定约束。",
  descriptionOfService: "服务描述",
  descriptionOfServiceDescription: "SafaCards是一个AI驱动的语言学习平台，提供：",
  personalizedVocabulary: "个性化词汇生成",
  interactiveFlashcards: "带间隔重复的互动闪卡",
  aiGeneratedSentences: "AI生成的练习句子",
  conversationalAITutoring: "对话式AI辅导",
  progressTracking: "进度跟踪和分析",
  userAccounts: "用户账户",
  userAccountsDescription: "要访问SafaCards的某些功能，您必须创建账户。您负责：",
  maintainConfidentiality: "维护账户凭据的机密性",
  allActivities: "在您账户下发生的所有活动",
  provideAccurateInfo: "提供准确和完整的信息",
  notifyUnauthorized: "立即通知我们任何未经授权的使用",
  acceptableUse: "可接受使用",
  acceptableUseDescription: "您同意不：",
  useForIllegal: "将服务用于任何非法或未经授权的目的",
  gainUnauthorizedAccess: "尝试获得对我们系统的未经授权访问",
  interfereWithService: "干扰或破坏服务",
  shareCredentials: "与他人共享您的账户凭据",
  useAutomatedTools: "使用自动化工具访问服务",
  createHarmfulContent: "创建有害、冒犯性或侵犯他人权利的内容",
  inappropriateContentPolicy: "SafaCards 不允许生成、上传或分享非法、仇恨、骚扰、色情或其他不当内容。我们可能会删除此类内容，并暂停违反本政策的账户。",
  intellectualProperty: "知识产权",
  intellectualPropertyDescription: "SafaCards及其原始内容、功能和功能归SafaCards所有，受国际版权、商标、专利、商业秘密和其他知识产权法律保护。",
  userContent: "用户内容",
  userContentDescription: "您保留使用我们服务创建的内容的所有权。通过使用SafaCards，您授予我们仅出于提供我们服务的目的使用、存储和显示您内容的许可。",
  privacy: "隐私",
  privacyDescription: "您的隐私对我们很重要。请查看我们的隐私政策，它也管理您对服务的使用。",
  disclaimers: "免责声明",
  disclaimersDescription: "服务按\"原样\"提供，不提供任何形式的保证。我们不保证服务将不间断、安全或无错误。",
  limitationOfLiability: "责任限制",
  limitationOfLiabilityDescription: "在任何情况下，SafaCards都不对因您使用服务而产生或与之相关的任何间接、偶然、特殊、后果性或惩罚性损害承担责任。",
  termination: "终止",
  terminationDescription: "我们可能随时终止或暂停您的账户和服务访问权限，无论是否有原因，无论是否事先通知。",
  changesToTerms: "条款变更",
  changesToTermsDescription: "我们保留随时修改这些条款的权利。我们将通过在此页面上发布新条款来通知用户任何重大变更。",
  contactInformation: "联系信息",
  contactInformationDescription: "如果您对这些服务条款有任何疑问，请通过 trysafacards@gmail.com 联系我们。",

  // Authentication
  signUp: "注册",
  password: "密码",
  confirmPassword: "确认密码",
  passwordsDoNotMatch: "密码不匹配。",
  passwordMinLength: "密码必须至少包含8个字符。",
  signupFailed: "注册失败。",
  checkEmailConfirmAccount: "请检查您的电子邮件以确认您的账户！",
  googleAuthFailed: "启动Google身份验证失败。",
  creatingAccount: "创建账户中...",
  continueWithGoogle: "使用Google继续",
  alreadyHaveAccount: "已有账户？",
  forgotPassword: "忘记密码？",
  forgotPasswordDescription: "输入您的电子邮件地址，我们将向您发送重置密码的链接。",
  sendResetLink: "发送重置链接",
  sending: "发送中...",
  backToLogin: "返回登录",
  newPassword: "新密码",
  confirmNewPassword: "确认新密码",
  resetPassword: "重置密码",
  resetting: "重置中...",
  passwordUpdated: "密码已更新！您现在可以登录了。",
  invalidResetLink: "重置链接无效或已过期。",
  failedToSetSession: "设置会话失败。链接可能无效或已过期。",
  failedToResetPassword: "重置密码失败。链接可能已过期。",
  createPassword: "创建密码",
  completeSetup: "完成设置",
  loggingIn: "登录中...",
  notSet: "未设置",
  showHint: "显示提示",
  hint: "提示",
  practiceMultipleChoice: "多项选择练习",
  gettingStarted: "开始",
  gettingStartedDescription: "让我们用 AI 生成的词汇创建您的第一个语言学习模块！",
  onboardingWelcome: "欢迎使用 SafaCards！",
  onboardingThanks: "感谢您的注册！",
  onboardingTrial: "为了让您充分体验 SafaCards，我们为您提供 3 天免费高级会员——无需绑定。尽情畅享所有功能！",
  onboardingPremiumFeaturesTitle: "高级会员能做什么？",
  onboardingPremiumFeature1: "每天可用 AI 添加多达 100 个新单词（免费用户为 10 个）",
  onboardingPremiumFeature2: "每天可练习 20 次 AI 对话（免费用户为 3 次）",
  onboardingPremiumFeature3: "体验所有高级练习和复习工具",
  onboardingPremiumFeature4: "无广告畅享 SafaCards",
  onboardingGettingStarted: "很高兴有你加入。以下是 SafaCards 的入门指南：",
  onboardingStep1: "进入仪表板（点击下方\"前往仪表板\"）以创建或进入语言模块。",
  onboardingStep2: "为你的模块添加单词——你可以自己输入，也可以让 AI 推荐适合你兴趣、水平，甚至特定方言的单词。AI 可以帮助你个性化学习！",
  onboardingStep3: "生成自定义测验，并在单词组中使用其他 AI 工具，如句子生成和练习活动。",
  onboardingStep4: "通过闪卡复习帮助记忆：使用学习模式结合 SM-2 间隔记忆系统，或切换到常规模式进行快速复习。",
  onboardingStep5: "随时在页面顶部绿色横幅中查看你的进度和使用情况。",
  onboardingGetStarted: "开始",
  onboardingPickLanguage: "选择应用语言：",
  onboardingGoToDashboard: "前往仪表板",
  storeUpgradeTitle: "升级为高级会员",
  storeMonthlyPrice: "¥35/月",
  storeYearlyPrice: "¥350/年",

  // Classroom Plans
  priceFamilyMonthly: "$4.99/月",
  priceFamilySemester: "$17.99 / 4个月",
  priceFamilyYearly: "$49.99/年",
  priceBasicMonthly: "$14.99/月",
  priceBasicSemester: "$54.99 / 4个月",
  priceBasicYearly: "$149.99/年",
  priceStandardMonthly: "$49.99/月",
  priceStandardSemester: "$179.99 / 4个月",
  priceStandardYearly: "$499.99/年",

  totalPrice: "总价",
  storeFeature1: "用 AI 推荐添加单词，适合你的兴趣、水平和方言",
  storeFeature2: "生成自定义测验并在单词组中使用更多 AI 工具",
  storeFeature3: "用 SM-2 系统和多种模式复习闪卡",
  storeFeature4: "无限 AI 对话，每天更多新单词",
  storeFeature5: "高级版无广告！",
  storeDailyLimitsTitle: "每日限制",
  storeFree: "免费",
  storePremium: "高级会员",
  storeWordsWithAI: "可用 AI 添加的单词数",
  storeAIConversations: "AI 对话次数",
  storeRedirecting: "正在跳转...",
  storeUpgradeMonthly: "升级为高级会员（月付）",
  storeUpgradeYearly: "升级为高级会员（年付）",
  storeBackToDashboard: "返回仪表板",
  storeRecurringNotice: "订阅是自动续费的，在您通过[PROFILE_PAGE]修改或取消计划之前，订阅将一直持续。",
  profilePage: "“个人资料”页面",
  thankYouTitle: "感谢！",
  thankYouSuccessLine1: "您已成功升级为 SafaCards 高级会员。",
  thankYouSuccessLine2: "现在可以畅享所有高级功能！",
  thankYouGoToDashboard: "前往仪表板",
  bannerWords: "单词",
  bannerPractice: "练习",
  store: "商店",
  storeMustBeLoggedIn: "您必须登录才能升级。",
  storeFailedToStartCheckout: "启动结账失败：{error}",
  aiAbbreviation: "AI",
  renew: "续订",
  supportTitle: "支持与联系",
  supportIntro: "需要帮助？请在下方联系我们或随时发送电子邮件。",
  supportEmailLabel: "邮箱：",
  supportPhoneLabel: "电话：",
  refundPolicy: "应用内购买一律不予退款。",
  refundPolicyTitle: "退款政策",

  // New keys from English
  cardsRemaining: "剩余卡片：{count}",
  noDueWords: "恭喜！您没有更多需要复习的单词了。",
  returnToModule: "返回模块",
  cardsLeft: "剩余卡片：",
  reviewDueWords: "复习到期单词",
  reviewDueWordsDescription: "专注于根据您的进度今天或之前到期的卡片。",
  reviewDueWordsFeature1: "仅显示今天或之前到期的卡片",
  reviewDueWordsFeature2: "基于SM2间隔重复数据，一种经过科学验证的学习方法",
  reviewDueWordsFeature3: "帮助改善长期记忆",
  startReview: "开始复习",
  learnUnmasteredWords: "学习未掌握单词",
  reviewWeakWords: "复习最薄弱的单词",
  reviewForgottenWords: "复习遗忘的单词",
  weakWordsModeInfo: "复习你最薄弱的单词。专注于这些单词以加强你的记忆。",
  forgottenWordsModeInfo: "复习你有一段时间没练习过的单词。专注于这些词，保持记忆新鲜！",
  unmasteredWordsLeft: "未掌握单词剩余:",
  allWordsMastered: "所有单词都已掌握！做得很好！",
  congratulationsAllWordsMastered: "恭喜！您已经掌握了所有单词！",

  // Demo and Landing Page
  wantToSeeSample: "想看看示例单词组吗？",
  previewWordGroup: "在注册前预览单词组的外观和工作方式。",
  viewDemoWordgroup: "查看演示单词组",
  wantTipsOnSafaCards: "想要了解如何最好地使用SafaCards的提示吗？",
  checkOutQuickStart: "查看我们的快速入门指南，充分利用您的学习。",
  viewHowToGuide: "查看使用指南",
  sm2GuideCardTitle: "间隔重复（SM‑2）指南",
  sm2GuideCardDesc: "先使用学习模式，再使用“复习所有单词”（SM‑2）以更好地记忆。",
  sm2GuideCardCTA: "阅读 SM‑2 指南",
  consentMessage: "我们使用 Cookie 改善体验并展示广告。请选择个性化或非个性化广告。",
  consentNonPersonalized: "非个性化",
  consentPersonalized: "个性化",
  demoNotice: "演示通知：",
  demoNoticeDescription: "下面的单词组是静态的，没有实时生成内容。在实际应用中，使用MCQ、FIB和Story功能将为您的选定单词和主题实时生成新的适当句子。",
  demoWordsGenerated: "此演示单词组中的单词是通过提示真实应用程序创建25个从英语到西班牙语的单词，主题为\"旅行\"，使用墨西哥方言。",

  // Missing keys from English
  checkEmailResetLink: "请检查您的电子邮件获取密码重置链接！",
  completingSignIn: "正在完成登录",
  createYourPassword: "创建您的密码",
  dontHaveAccount: "没有账户？",
  failedToSendResetEmail: "发送重置电子邮件失败。",
  failedToSetPassword: "设置密码失败。请重试。",
  goToSupport: "前往支持",
  howToUseSafaCards: "如何使用 SafaCards",
  howToUseSafaCardsSubtitle: "智能语言学习快速入门指南",
  invalidPasswordCreationLink: "密码创建链接无效",
  loginFailed: "登录失败。",
  mustCreateAccountForAI: "要使用 AI 生成单词，您必须登录。",
  needHelp: "需要帮助？",
  needHelpDescription: "访问我们的支持页面获取常见问题、提示或直接联系我们。",
  needPremiumForAIFeedback: "要获得故事解释的评分，请创建账户。",
  passwordSetButSignInFailed: "密码设置成功，但登录失败。请尝试手动登录。",
  redirectingToCompleteAuth: "正在重定向以完成身份验证...",
  returnToWordGroup: "返回单词组",
  sm2ModeInfo: "到期单词复习模式：使用 ✓ 或 ✗ 前进，或使用 ←/→ 箭头键。仅显示到期单词。",
  sm2UndoLastCard: "返回上一张卡片",
  step1CreateAccount: "第1步：创建账户",
  step1Description: "使用您的电子邮件或 Google 账户注册开始。这为您提供 SafaCards 智能学习工具的访问权限，并允许您保存进度。",
  step2Description: "模块定义您学习的语言对（例如，西班牙语到英语）。您将选择源语言和目标语言——这确保您的所有单词组、测验和内容都与您的目标保持一致。",
  step2PickGroup: "第2步：创建模块",
  step3Description: "在每个模块中，手动创建单词组或让 SafaCards 为您生成。您可以选择主题、方言（如墨西哥西班牙语或魁北克法语）以及想要的单词数量。AI 将找到适合您需求的相关单词。",
  step3LearnInContext: "第3步：构建单词组",
  step4Description: "一旦有了单词组，使用闪卡学习（常规模式或 SM-2 学习模式）、AI 生成的多项选择和填空测验来评估您的理解，或完整的故事生成。故事帮助您在沉浸式语境中看到和使用您的单词，SafaCards 将评估您的回答，以便您继续改进。",
  step4PracticeAI: "第4步：使用智能工具学习",
  supportFormIntro: "或使用下面的表单向我们发送消息：",
  supportThankYou: "感谢您的联系！我们会尽快回复您。",
  tryDemo: "尝试演示",
  tryDemoDescription: "还没准备好注册？现在预览真实的演示组。",
  viewDemoGroup: "查看演示单词组",
  welcomeCreatePassword: "欢迎！请创建密码以完成您的账户设置。",
  yourEmail: "您的邮箱",
  yourMessage: "您的消息",
  yourName: "您的姓名"
}; 
